/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AttachDimensionRequest } from '../models/attachDimensionRequest';

import type { BatchEntriesRequest } from '../models/batchEntriesRequest';

import type { BodyCommitInventoryImport } from '../models/bodyCommitInventoryImport';

import type { BodyFinishInventoryImportRun } from '../models/bodyFinishInventoryImportRun';

import type { BodyInspectInventoryImport } from '../models/bodyInspectInventoryImport';

import type { BodyPlanCatalogImport } from '../models/bodyPlanCatalogImport';

import type { BodyPlanInventoryImport } from '../models/bodyPlanInventoryImport';

import type { BodyPreviewCatalogImport } from '../models/bodyPreviewCatalogImport';

import type { BodyPreviewCatalogImportPreset } from '../models/bodyPreviewCatalogImportPreset';

import type { BodyRunCatalogImport } from '../models/bodyRunCatalogImport';

import type { BodyRunCatalogImportPreset } from '../models/bodyRunCatalogImportPreset';

import type { BodyRunProductImageImport } from '../models/bodyRunProductImageImport';

import type { BulkProductRequest } from '../models/bulkProductRequest';

import type { BulkProductUpdateRequest } from '../models/bulkProductUpdateRequest';

import type { BundleItemRequest } from '../models/bundleItemRequest';

import type { BundleItemUpdateRequest } from '../models/bundleItemUpdateRequest';

import type { CatalogImportPlanResponse } from '../models/catalogImportPlanResponse';

import type { CatalogImportPresetPreviewResponse } from '../models/catalogImportPresetPreviewResponse';

import type { CatalogImportPreviewResponse } from '../models/catalogImportPreviewResponse';

import type { CatalogImportResultResponse } from '../models/catalogImportResultResponse';

import type { CategoryCoverageEntry } from '../models/categoryCoverageEntry';

import type { CategoryProductsRequest } from '../models/categoryProductsRequest';

import type { CategoryVendorCoverage } from '../models/categoryVendorCoverage';

import type { ConfigurationRequest } from '../models/configurationRequest';

import type { ConfigurationUpdateRequest } from '../models/configurationUpdateRequest';

import type { ConfigurationValueRequest } from '../models/configurationValueRequest';

import type { ConfigurationValueUpdateRequest } from '../models/configurationValueUpdateRequest';

import type { CustomOfferingRequest } from '../models/customOfferingRequest';

import type { DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody } from '../models/deleteProductApiV1MasterDataProductsProductsProductIdDeleteBody';

import type { DeletionImpact } from '../models/deletionImpact';

import type { DimensionRequest } from '../models/dimensionRequest';

import type { DimensionUpdateRequest } from '../models/dimensionUpdateRequest';

import type { DimensionValueRequest } from '../models/dimensionValueRequest';

import type { DimensionValueUpdateRequest } from '../models/dimensionValueUpdateRequest';

import type { GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams } from '../models/getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams';

import type { GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams } from '../models/getCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams';

import type { GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams } from '../models/getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams';

import type { GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams } from '../models/getPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams';

import type { GetProductApiV1MasterDataProductsProductsProductIdGetParams } from '../models/getProductApiV1MasterDataProductsProductsProductIdGetParams';

import type { GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams } from '../models/getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams';

import type { GetProductsDashboardApiV1MasterDataProductsDashboardGetParams } from '../models/getProductsDashboardApiV1MasterDataProductsDashboardGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { InventoryImportInspectResponse } from '../models/inventoryImportInspectResponse';

import type { InventoryImportPlanResponse } from '../models/inventoryImportPlanResponse';

import type { InventoryImportResultResponse } from '../models/inventoryImportResultResponse';

import type { InventoryImportRun } from '../models/inventoryImportRun';

import type { InventoryImportRunExceptionListResponse } from '../models/inventoryImportRunExceptionListResponse';

import type { InventoryImportRunListResponse } from '../models/inventoryImportRunListResponse';

import type { ListCategoriesApiV1MasterDataProductsCategoriesGetParams } from '../models/listCategoriesApiV1MasterDataProductsCategoriesGetParams';

import type { ListInventoryImportRunExceptionsParams } from '../models/listInventoryImportRunExceptionsParams';

import type { ListInventoryImportRunsParams } from '../models/listInventoryImportRunsParams';

import type { ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams } from '../models/listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams';

import type { ListPriceListsApiV1MasterDataProductsPriceListsGetParams } from '../models/listPriceListsApiV1MasterDataProductsPriceListsGetParams';

import type { ListProductsApiV1MasterDataProductsProductsGetParams } from '../models/listProductsApiV1MasterDataProductsProductsGetParams';

import type { ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams } from '../models/listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams';

import type { ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams } from '../models/listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams';

import type { PriceListEntryRequest } from '../models/priceListEntryRequest';

import type { PriceListRequest } from '../models/priceListRequest';

import type { PriceListUpdateRequest } from '../models/priceListUpdateRequest';

import type { ProductAddonRequest } from '../models/productAddonRequest';

import type { ProductCatalogLayersRequest } from '../models/productCatalogLayersRequest';

import type { ProductCatalogLayersResponse } from '../models/productCatalogLayersResponse';

import type { ProductCategoryRequest } from '../models/productCategoryRequest';

import type { ProductCategoryUpdateRequest } from '../models/productCategoryUpdateRequest';

import type { ProductDefaultPackagingRequest } from '../models/productDefaultPackagingRequest';

import type { ProductHsCodeRequest } from '../models/productHsCodeRequest';

import type { ProductImageImportPreviewRequest } from '../models/productImageImportPreviewRequest';

import type { ProductImageImportPreviewResponse } from '../models/productImageImportPreviewResponse';

import type { ProductImageImportResultResponse } from '../models/productImageImportResultResponse';

import type { ProductPackagingCreateRequest } from '../models/productPackagingCreateRequest';

import type { ProductPackagingUpdateRequest } from '../models/productPackagingUpdateRequest';

import type { ProductReferenceResolveRequest } from '../models/productReferenceResolveRequest';

import type { ProductRequest } from '../models/productRequest';

import type { ProductTaxCategoryCreate } from '../models/productTaxCategoryCreate';

import type { ProductTaxCategoryListResponse } from '../models/productTaxCategoryListResponse';

import type { ProductTaxCategoryResponse } from '../models/productTaxCategoryResponse';

import type { ProductTaxCategoryUpdate } from '../models/productTaxCategoryUpdate';

import type { ProductUpdateRequest } from '../models/productUpdateRequest';

import type { ProductUrlEnrichmentRequest } from '../models/productUrlEnrichmentRequest';

import type { ProductVariantFlatCreate } from '../models/productVariantFlatCreate';

import type { ProductVariantListResponse } from '../models/productVariantListResponse';

import type { ProductVariantRequest } from '../models/productVariantRequest';

import type { ProductVariantResponse } from '../models/productVariantResponse';

import type { ProductVendorSku } from '../models/productVendorSku';

import type { ProductVendorSkuRequest } from '../models/productVendorSkuRequest';

import type { ProductVendorSkuUpdateRequest } from '../models/productVendorSkuUpdateRequest';

import type { ProductWarehouseAccountRequest } from '../models/productWarehouseAccountRequest';

import type { ProductWarehouseAccountUpdateRequest } from '../models/productWarehouseAccountUpdateRequest';

import type { ProductsDashboard } from '../models/productsDashboard';

import type { VariantGenerateRequest } from '../models/variantGenerateRequest';

import type { VariantResolveRequest } from '../models/variantResolveRequest';

import type { VendorCategoryCoverage } from '../models/vendorCategoryCoverage';

import type { VendorCategoryCoverageCreate } from '../models/vendorCategoryCoverageCreate';

import type { VendorCategoryCoverageDeleteResult } from '../models/vendorCategoryCoverageDeleteResult';

import type { VendorCategoryCoverageResponse } from '../models/vendorCategoryCoverageResponse';

import type { VendorCategoryCoverageUpdate } from '../models/vendorCategoryCoverageUpdate';

import type { VendorProductOffering } from '../models/vendorProductOffering';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Products dashboard KPIs: overview counts, products-by-category, and the
recently-added products feed.

Served through the shared KPI substrate (schema-first ``response_model`` +
``cached_kpi``); see docs/platform/dashboard-kpi-endpoints.md. Sharing Contract C:
the ``master_data.product`` scope and the active-company scope are resolved HERE,
outside ``cached_kpi``, per the ordering invariant — scope resolution writes the
bounded ``admin_override_read`` audit row for a Full-Access admin's universal read
(a cache hit must not skip it) and 403s a forged ``X-Active-Company-Id``. In a
restricted visibility mode every product aggregate is scoped and the payload is
per-viewer; in everyone mode / for tenant admins the scope is None and the numbers
are byte-identical to today.
 * @summary Get Products Dashboard
 */
export const getProductsDashboardApiV1MasterDataProductsDashboardGet = (
  params?: GetProductsDashboardApiV1MasterDataProductsDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ProductsDashboard>({
    url: `/api/v1/master-data/products/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetProductsDashboardApiV1MasterDataProductsDashboardGetQueryKey =
  (params?: GetProductsDashboardApiV1MasterDataProductsDashboardGetParams) => {
    return [
      `/api/v1/master-data/products/dashboard`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetProductsDashboardApiV1MasterDataProductsDashboardGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getProductsDashboardApiV1MasterDataProductsDashboardGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetProductsDashboardApiV1MasterDataProductsDashboardGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetProductsDashboardApiV1MasterDataProductsDashboardGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
        >
      >
    > = ({ signal }) =>
      getProductsDashboardApiV1MasterDataProductsDashboardGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetProductsDashboardApiV1MasterDataProductsDashboardGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getProductsDashboardApiV1MasterDataProductsDashboardGet>
    >
  >;
export type GetProductsDashboardApiV1MasterDataProductsDashboardGetQueryError =
  HTTPValidationError;

export function useGetProductsDashboardApiV1MasterDataProductsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getProductsDashboardApiV1MasterDataProductsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetProductsDashboardApiV1MasterDataProductsDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProductsDashboardApiV1MasterDataProductsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getProductsDashboardApiV1MasterDataProductsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetProductsDashboardApiV1MasterDataProductsDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProductsDashboardApiV1MasterDataProductsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getProductsDashboardApiV1MasterDataProductsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetProductsDashboardApiV1MasterDataProductsDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Products Dashboard
 */

export function useGetProductsDashboardApiV1MasterDataProductsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getProductsDashboardApiV1MasterDataProductsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetProductsDashboardApiV1MasterDataProductsDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductsDashboardApiV1MasterDataProductsDashboardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProductsDashboardApiV1MasterDataProductsDashboardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all product categories (flat). With ``include_products``, attach the
active product count and up to 3 previews per category.
 * @summary List Categories
 */
export const listCategoriesApiV1MasterDataProductsCategoriesGet = (
  params?: ListCategoriesApiV1MasterDataProductsCategoriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/categories`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCategoriesApiV1MasterDataProductsCategoriesGetQueryKey = (
  params?: ListCategoriesApiV1MasterDataProductsCategoriesGetParams
) => {
  return [
    `/api/v1/master-data/products/categories`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListCategoriesApiV1MasterDataProductsCategoriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListCategoriesApiV1MasterDataProductsCategoriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCategoriesApiV1MasterDataProductsCategoriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCategoriesApiV1MasterDataProductsCategoriesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
      >
    > = ({ signal }) =>
      listCategoriesApiV1MasterDataProductsCategoriesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCategoriesApiV1MasterDataProductsCategoriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
    >
  >;
export type ListCategoriesApiV1MasterDataProductsCategoriesGetQueryError =
  HTTPValidationError;

export function useListCategoriesApiV1MasterDataProductsCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListCategoriesApiV1MasterDataProductsCategoriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoriesApiV1MasterDataProductsCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoriesApiV1MasterDataProductsCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCategoriesApiV1MasterDataProductsCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCategoriesApiV1MasterDataProductsCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoriesApiV1MasterDataProductsCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoriesApiV1MasterDataProductsCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCategoriesApiV1MasterDataProductsCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCategoriesApiV1MasterDataProductsCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Categories
 */

export function useListCategoriesApiV1MasterDataProductsCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCategoriesApiV1MasterDataProductsCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listCategoriesApiV1MasterDataProductsCategoriesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCategoriesApiV1MasterDataProductsCategoriesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new product category.
 * @summary Create Category
 */
export const createCategoryApiV1MasterDataProductsCategoriesPost = (
  productCategoryRequest: ProductCategoryRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/categories`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: productCategoryRequest,
    signal
  });
};

export const getCreateCategoryApiV1MasterDataProductsCategoriesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createCategoryApiV1MasterDataProductsCategoriesPost>
      >,
      TError,
      { data: ProductCategoryRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createCategoryApiV1MasterDataProductsCategoriesPost>
    >,
    TError,
    { data: ProductCategoryRequest },
    TContext
  > => {
    const mutationKey = ['createCategoryApiV1MasterDataProductsCategoriesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createCategoryApiV1MasterDataProductsCategoriesPost>
      >,
      { data: ProductCategoryRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createCategoryApiV1MasterDataProductsCategoriesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCategoryApiV1MasterDataProductsCategoriesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createCategoryApiV1MasterDataProductsCategoriesPost>
    >
  >;
export type CreateCategoryApiV1MasterDataProductsCategoriesPostMutationBody =
  ProductCategoryRequest;
export type CreateCategoryApiV1MasterDataProductsCategoriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Category
 */
export const useCreateCategoryApiV1MasterDataProductsCategoriesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createCategoryApiV1MasterDataProductsCategoriesPost>
      >,
      TError,
      { data: ProductCategoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createCategoryApiV1MasterDataProductsCategoriesPost>
  >,
  TError,
  { data: ProductCategoryRequest },
  TContext
> => {
  const mutationOptions =
    getCreateCategoryApiV1MasterDataProductsCategoriesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Return categories as a nested tree (roots with recursive ``children``).
 * @summary Get Category Tree
 */
export const getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet = (
  params?: GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/categories/tree`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetQueryKey =
  (params?: GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams) => {
    return [
      `/api/v1/master-data/products/categories/tree`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
        >
      >
    > = ({ signal }) =>
      getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet>
    >
  >;
export type GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetQueryError =
  HTTPValidationError;

export function useGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGet<
  TData = Awaited<
    ReturnType<typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGet<
  TData = Awaited<
    ReturnType<typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGet<
  TData = Awaited<
    ReturnType<typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Category Tree
 */

export function useGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGet<
  TData = Awaited<
    ReturnType<typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryTreeApiV1MasterDataProductsCategoriesTreeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCategoryTreeApiV1MasterDataProductsCategoriesTreeGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a product category by ID.
 * @summary Get Category
 */
export const getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet = (
  categoryId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/categories/${categoryId}`,
    method: 'GET',
    signal
  });
};

export const getGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGetQueryKey =
  (categoryId?: string) => {
    return [`/api/v1/master-data/products/categories/${categoryId}`] as const;
  };

export const getGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    categoryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGetQueryKey(
        categoryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
        >
      >
    > = ({ signal }) =>
      getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet(
        categoryId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!categoryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCategoryApiV1MasterDataProductsCategoriesCategoryIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
      >
    >
  >;
export type GetCategoryApiV1MasterDataProductsCategoriesCategoryIdGetQueryError =
  HTTPValidationError;

export function useGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Category
 */

export function useGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGet<
  TData = Awaited<
    ReturnType<typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet>
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryApiV1MasterDataProductsCategoriesCategoryIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCategoryApiV1MasterDataProductsCategoriesCategoryIdGetQueryOptions(
      categoryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a product category.
 * @summary Update Category
 */
export const updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut = (
  categoryId: string,
  productCategoryUpdateRequest: ProductCategoryUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/categories/${categoryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: productCategoryUpdateRequest
  });
};

export const getUpdateCategoryApiV1MasterDataProductsCategoriesCategoryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut
        >
      >,
      TError,
      { categoryId: string; data: ProductCategoryUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut
      >
    >,
    TError,
    { categoryId: string; data: ProductCategoryUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut
        >
      >,
      { categoryId: string; data: ProductCategoryUpdateRequest }
    > = (props) => {
      const { categoryId, data } = props ?? {};

      return updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut(
        categoryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCategoryApiV1MasterDataProductsCategoriesCategoryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut
      >
    >
  >;
export type UpdateCategoryApiV1MasterDataProductsCategoriesCategoryIdPutMutationBody =
  ProductCategoryUpdateRequest;
export type UpdateCategoryApiV1MasterDataProductsCategoriesCategoryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Category
 */
export const useUpdateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut
        >
      >,
      TError,
      { categoryId: string; data: ProductCategoryUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateCategoryApiV1MasterDataProductsCategoriesCategoryIdPut
    >
  >,
  TError,
  { categoryId: string; data: ProductCategoryUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateCategoryApiV1MasterDataProductsCategoriesCategoryIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a product category.
 * @summary Delete Category
 */
export const deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete = (
  categoryId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/categories/${categoryId}`,
    method: 'DELETE'
  });
};

export const getDeleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete
        >
      >,
      TError,
      { categoryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete
      >
    >,
    TError,
    { categoryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete
        >
      >,
      { categoryId: string }
    > = (props) => {
      const { categoryId } = props ?? {};

      return deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete(
        categoryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete
      >
    >
  >;

export type DeleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Category
 */
export const useDeleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete
          >
        >,
        TError,
        { categoryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDelete
      >
    >,
    TError,
    { categoryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteCategoryApiV1MasterDataProductsCategoriesCategoryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the tenant's product tax categories (name-ordered, with usage counts).
 * @summary List Tax Categories
 */
export const listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet = (
  params?: ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ProductTaxCategoryListResponse>({
    url: `/api/v1/master-data/products/tax-categories`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetQueryKey =
  (params?: ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams) => {
    return [
      `/api/v1/master-data/products/tax-categories`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
        >
      >
    > = ({ signal }) =>
      listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
      >
    >
  >;
export type ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetQueryError =
  HTTPValidationError;

export function useListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tax Categories
 */

export function useListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet<
  TData = Awaited<
    ReturnType<typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaxCategoriesApiV1MasterDataProductsTaxCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTaxCategoriesApiV1MasterDataProductsTaxCategoriesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new product tax category.
 * @summary Create Tax Category
 */
export const createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost = (
  productTaxCategoryCreate: ProductTaxCategoryCreate,
  signal?: AbortSignal
) => {
  return customInstance<ProductTaxCategoryResponse>({
    url: `/api/v1/master-data/products/tax-categories`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: productTaxCategoryCreate,
    signal
  });
};

export const getCreateTaxCategoryApiV1MasterDataProductsTaxCategoriesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost
        >
      >,
      TError,
      { data: ProductTaxCategoryCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost
      >
    >,
    TError,
    { data: ProductTaxCategoryCreate },
    TContext
  > => {
    const mutationKey = [
      'createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost
        >
      >,
      { data: ProductTaxCategoryCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTaxCategoryApiV1MasterDataProductsTaxCategoriesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost
      >
    >
  >;
export type CreateTaxCategoryApiV1MasterDataProductsTaxCategoriesPostMutationBody =
  ProductTaxCategoryCreate;
export type CreateTaxCategoryApiV1MasterDataProductsTaxCategoriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Tax Category
 */
export const useCreateTaxCategoryApiV1MasterDataProductsTaxCategoriesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost
        >
      >,
      TError,
      { data: ProductTaxCategoryCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createTaxCategoryApiV1MasterDataProductsTaxCategoriesPost>
  >,
  TError,
  { data: ProductTaxCategoryCreate },
  TContext
> => {
  const mutationOptions =
    getCreateTaxCategoryApiV1MasterDataProductsTaxCategoriesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a product tax category. Renaming `code` cascades to its products.
 * @summary Update Tax Category
 */
export const updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut =
  (
    taxCategoryId: string,
    productTaxCategoryUpdate: ProductTaxCategoryUpdate
  ) => {
    return customInstance<ProductTaxCategoryResponse>({
      url: `/api/v1/master-data/products/tax-categories/${taxCategoryId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: productTaxCategoryUpdate
    });
  };

export const getUpdateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut
        >
      >,
      TError,
      { taxCategoryId: string; data: ProductTaxCategoryUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut
      >
    >,
    TError,
    { taxCategoryId: string; data: ProductTaxCategoryUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut
        >
      >,
      { taxCategoryId: string; data: ProductTaxCategoryUpdate }
    > = (props) => {
      const { taxCategoryId, data } = props ?? {};

      return updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut(
        taxCategoryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut
      >
    >
  >;
export type UpdateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPutMutationBody =
  ProductTaxCategoryUpdate;
export type UpdateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tax Category
 */
export const useUpdateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut
          >
        >,
        TError,
        { taxCategoryId: string; data: ProductTaxCategoryUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPut
      >
    >,
    TError,
    { taxCategoryId: string; data: ProductTaxCategoryUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a product tax category (blocked while any product uses its code).
 * @summary Delete Tax Category
 */
export const deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete =
  (taxCategoryId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/tax-categories/${taxCategoryId}`,
      method: 'DELETE'
    });
  };

export const getDeleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete
        >
      >,
      TError,
      { taxCategoryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete
      >
    >,
    TError,
    { taxCategoryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete
        >
      >,
      { taxCategoryId: string }
    > = (props) => {
      const { taxCategoryId } = props ?? {};

      return deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete(
        taxCategoryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete
      >
    >
  >;

export type DeleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Tax Category
 */
export const useDeleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete
          >
        >,
        TError,
        { taxCategoryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDelete
      >
    >,
    TError,
    { taxCategoryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteTaxCategoryApiV1MasterDataProductsTaxCategoriesTaxCategoryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add a category to each of the given products (appends to their memberships).
 * @summary Add Products To Category
 */
export const addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost =
  (
    categoryId: string,
    categoryProductsRequest: CategoryProductsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/categories/${categoryId}/products`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: categoryProductsRequest,
      signal
    });
  };

export const getAddProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost
        >
      >,
      TError,
      { categoryId: string; data: CategoryProductsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost
      >
    >,
    TError,
    { categoryId: string; data: CategoryProductsRequest },
    TContext
  > => {
    const mutationKey = [
      'addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost
        >
      >,
      { categoryId: string; data: CategoryProductsRequest }
    > = (props) => {
      const { categoryId, data } = props ?? {};

      return addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost(
        categoryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost
      >
    >
  >;
export type AddProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPostMutationBody =
  CategoryProductsRequest;
export type AddProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Products To Category
 */
export const useAddProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost
          >
        >,
        TError,
        { categoryId: string; data: CategoryProductsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPost
      >
    >,
    TError,
    { categoryId: string; data: CategoryProductsRequest },
    TContext
  > => {
    const mutationOptions =
      getAddProductsToCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a category from a single product's memberships.
 * @summary Remove Product From Category
 */
export const removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete =
  (categoryId: string, productId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/categories/${categoryId}/products/${productId}`,
      method: 'DELETE'
    });
  };

export const getRemoveProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete
        >
      >,
      TError,
      { categoryId: string; productId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete
      >
    >,
    TError,
    { categoryId: string; productId: string },
    TContext
  > => {
    const mutationKey = [
      'removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete
        >
      >,
      { categoryId: string; productId: string }
    > = (props) => {
      const { categoryId, productId } = props ?? {};

      return removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete(
        categoryId,
        productId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete
      >
    >
  >;

export type RemoveProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Product From Category
 */
export const useRemoveProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete
          >
        >,
        TError,
        { categoryId: string; productId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDelete
      >
    >,
    TError,
    { categoryId: string; productId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveProductFromCategoryApiV1MasterDataProductsCategoriesCategoryIdProductsProductIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all products with optional filters, server-side sort and page window.
 * @summary List Products
 */
export const listProductsApiV1MasterDataProductsProductsGet = (
  params?: ListProductsApiV1MasterDataProductsProductsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products`,
    method: 'GET',
    params,
    signal
  });
};

export const getListProductsApiV1MasterDataProductsProductsGetQueryKey = (
  params?: ListProductsApiV1MasterDataProductsProductsGetParams
) => {
  return [
    `/api/v1/master-data/products/products`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListProductsApiV1MasterDataProductsProductsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListProductsApiV1MasterDataProductsProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListProductsApiV1MasterDataProductsProductsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>>
  > = ({ signal }) =>
    listProductsApiV1MasterDataProductsProductsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListProductsApiV1MasterDataProductsProductsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>>
  >;
export type ListProductsApiV1MasterDataProductsProductsGetQueryError =
  HTTPValidationError;

export function useListProductsApiV1MasterDataProductsProductsGet<
  TData = Awaited<
    ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListProductsApiV1MasterDataProductsProductsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductsApiV1MasterDataProductsProductsGet<
  TData = Awaited<
    ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListProductsApiV1MasterDataProductsProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductsApiV1MasterDataProductsProductsGet<
  TData = Awaited<
    ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListProductsApiV1MasterDataProductsProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Products
 */

export function useListProductsApiV1MasterDataProductsProductsGet<
  TData = Awaited<
    ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListProductsApiV1MasterDataProductsProductsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProductsApiV1MasterDataProductsProductsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductsApiV1MasterDataProductsProductsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new product.
 * @summary Create Product
 */
export const createProductApiV1MasterDataProductsProductsPost = (
  productRequest: ProductRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: productRequest,
    signal
  });
};

export const getCreateProductApiV1MasterDataProductsProductsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createProductApiV1MasterDataProductsProductsPost>
      >,
      TError,
      { data: ProductRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createProductApiV1MasterDataProductsProductsPost>
    >,
    TError,
    { data: ProductRequest },
    TContext
  > => {
    const mutationKey = ['createProductApiV1MasterDataProductsProductsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createProductApiV1MasterDataProductsProductsPost>
      >,
      { data: ProductRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createProductApiV1MasterDataProductsProductsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateProductApiV1MasterDataProductsProductsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createProductApiV1MasterDataProductsProductsPost>>
  >;
export type CreateProductApiV1MasterDataProductsProductsPostMutationBody =
  ProductRequest;
export type CreateProductApiV1MasterDataProductsProductsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Product
 */
export const useCreateProductApiV1MasterDataProductsProductsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createProductApiV1MasterDataProductsProductsPost>
      >,
      TError,
      { data: ProductRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createProductApiV1MasterDataProductsProductsPost>>,
  TError,
  { data: ProductRequest },
  TContext
> => {
  const mutationOptions =
    getCreateProductApiV1MasterDataProductsProductsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a product by ID.
 * @summary Get Product
 */
export const getProductApiV1MasterDataProductsProductsProductIdGet = (
  productId: string,
  params?: GetProductApiV1MasterDataProductsProductsProductIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products/${productId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetProductApiV1MasterDataProductsProductsProductIdGetQueryKey =
  (
    productId?: string,
    params?: GetProductApiV1MasterDataProductsProductsProductIdGetParams
  ) => {
    return [
      `/api/v1/master-data/products/products/${productId}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetProductApiV1MasterDataProductsProductsProductIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    params?: GetProductApiV1MasterDataProductsProductsProductIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getProductApiV1MasterDataProductsProductsProductIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetProductApiV1MasterDataProductsProductsProductIdGetQueryKey(
        productId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
      >
    > = ({ signal }) =>
      getProductApiV1MasterDataProductsProductsProductIdGet(
        productId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetProductApiV1MasterDataProductsProductsProductIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
    >
  >;
export type GetProductApiV1MasterDataProductsProductsProductIdGetQueryError =
  HTTPValidationError;

export function useGetProductApiV1MasterDataProductsProductsProductIdGet<
  TData = Awaited<
    ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params:
    | undefined
    | GetProductApiV1MasterDataProductsProductsProductIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductApiV1MasterDataProductsProductsProductIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductApiV1MasterDataProductsProductsProductIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductApiV1MasterDataProductsProductsProductIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProductApiV1MasterDataProductsProductsProductIdGet<
  TData = Awaited<
    ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetProductApiV1MasterDataProductsProductsProductIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductApiV1MasterDataProductsProductsProductIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductApiV1MasterDataProductsProductsProductIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductApiV1MasterDataProductsProductsProductIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProductApiV1MasterDataProductsProductsProductIdGet<
  TData = Awaited<
    ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetProductApiV1MasterDataProductsProductsProductIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductApiV1MasterDataProductsProductsProductIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Product
 */

export function useGetProductApiV1MasterDataProductsProductsProductIdGet<
  TData = Awaited<
    ReturnType<typeof getProductApiV1MasterDataProductsProductsProductIdGet>
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetProductApiV1MasterDataProductsProductsProductIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductApiV1MasterDataProductsProductsProductIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProductApiV1MasterDataProductsProductsProductIdGetQueryOptions(
      productId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a product. All fields are optional - only provided fields will be updated.
 * @summary Update Product
 */
export const updateProductApiV1MasterDataProductsProductsProductIdPut = (
  productId: string,
  productUpdateRequest: ProductUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products/${productId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: productUpdateRequest
  });
};

export const getUpdateProductApiV1MasterDataProductsProductsProductIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductApiV1MasterDataProductsProductsProductIdPut
        >
      >,
      TError,
      { productId: string; data: ProductUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateProductApiV1MasterDataProductsProductsProductIdPut
      >
    >,
    TError,
    { productId: string; data: ProductUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateProductApiV1MasterDataProductsProductsProductIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateProductApiV1MasterDataProductsProductsProductIdPut
        >
      >,
      { productId: string; data: ProductUpdateRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return updateProductApiV1MasterDataProductsProductsProductIdPut(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateProductApiV1MasterDataProductsProductsProductIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateProductApiV1MasterDataProductsProductsProductIdPut
      >
    >
  >;
export type UpdateProductApiV1MasterDataProductsProductsProductIdPutMutationBody =
  ProductUpdateRequest;
export type UpdateProductApiV1MasterDataProductsProductsProductIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Product
 */
export const useUpdateProductApiV1MasterDataProductsProductsProductIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductApiV1MasterDataProductsProductsProductIdPut
        >
      >,
      TError,
      { productId: string; data: ProductUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateProductApiV1MasterDataProductsProductsProductIdPut>
  >,
  TError,
  { productId: string; data: ProductUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateProductApiV1MasterDataProductsProductsProductIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a product, applying any options chosen in the impact preview.
 * @summary Delete Product
 */
export const deleteProductApiV1MasterDataProductsProductsProductIdDelete = (
  productId: string,
  deleteProductApiV1MasterDataProductsProductsProductIdDeleteBody: DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products/${productId}`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteProductApiV1MasterDataProductsProductsProductIdDeleteBody
  });
};

export const getDeleteProductApiV1MasterDataProductsProductsProductIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductApiV1MasterDataProductsProductsProductIdDelete
        >
      >,
      TError,
      {
        productId: string;
        data: DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteProductApiV1MasterDataProductsProductsProductIdDelete
      >
    >,
    TError,
    {
      productId: string;
      data: DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody;
    },
    TContext
  > => {
    const mutationKey = [
      'deleteProductApiV1MasterDataProductsProductsProductIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteProductApiV1MasterDataProductsProductsProductIdDelete
        >
      >,
      {
        productId: string;
        data: DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody;
      }
    > = (props) => {
      const { productId, data } = props ?? {};

      return deleteProductApiV1MasterDataProductsProductsProductIdDelete(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteProductApiV1MasterDataProductsProductsProductIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteProductApiV1MasterDataProductsProductsProductIdDelete
      >
    >
  >;
export type DeleteProductApiV1MasterDataProductsProductsProductIdDeleteMutationBody =
  DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody;
export type DeleteProductApiV1MasterDataProductsProductsProductIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Product
 */
export const useDeleteProductApiV1MasterDataProductsProductsProductIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductApiV1MasterDataProductsProductsProductIdDelete
        >
      >,
      TError,
      {
        productId: string;
        data: DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteProductApiV1MasterDataProductsProductsProductIdDelete
    >
  >,
  TError,
  {
    productId: string;
    data: DeleteProductApiV1MasterDataProductsProductsProductIdDeleteBody;
  },
  TContext
> => {
  const mutationOptions =
    getDeleteProductApiV1MasterDataProductsProductsProductIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Auto-create a minimal custom make_to_order offering (Decision D2).
 * @summary Create Custom Offering
 */
export const createCustomOfferingApiV1MasterDataProductsCustomOfferingPost = (
  customOfferingRequest: CustomOfferingRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/custom-offering`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: customOfferingRequest,
    signal
  });
};

export const getCreateCustomOfferingApiV1MasterDataProductsCustomOfferingPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCustomOfferingApiV1MasterDataProductsCustomOfferingPost
        >
      >,
      TError,
      { data: CustomOfferingRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCustomOfferingApiV1MasterDataProductsCustomOfferingPost
      >
    >,
    TError,
    { data: CustomOfferingRequest },
    TContext
  > => {
    const mutationKey = [
      'createCustomOfferingApiV1MasterDataProductsCustomOfferingPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCustomOfferingApiV1MasterDataProductsCustomOfferingPost
        >
      >,
      { data: CustomOfferingRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createCustomOfferingApiV1MasterDataProductsCustomOfferingPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCustomOfferingApiV1MasterDataProductsCustomOfferingPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCustomOfferingApiV1MasterDataProductsCustomOfferingPost
      >
    >
  >;
export type CreateCustomOfferingApiV1MasterDataProductsCustomOfferingPostMutationBody =
  CustomOfferingRequest;
export type CreateCustomOfferingApiV1MasterDataProductsCustomOfferingPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Custom Offering
 */
export const useCreateCustomOfferingApiV1MasterDataProductsCustomOfferingPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCustomOfferingApiV1MasterDataProductsCustomOfferingPost
          >
        >,
        TError,
        { data: CustomOfferingRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCustomOfferingApiV1MasterDataProductsCustomOfferingPost
      >
    >,
    TError,
    { data: CustomOfferingRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateCustomOfferingApiV1MasterDataProductsCustomOfferingPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deletion-impact preview for a product (deletion-and-cascade-design §5.1):
blockers / cascades / references-kept / options. Read-only; called when the
delete dialog opens.
 * @summary Get Product Deletion Impact
 */
export const getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<DeletionImpact>({
      url: `/api/v1/master-data/products/products/${productId}/deletion-impact`,
      method: 'GET',
      signal
    });
  };

export const getGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/deletion-impact`
    ] as const;
  };

export const getGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
        >
      >
    > = ({ signal }) =>
      getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
      >
    >
  >;
export type GetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGetQueryError =
  HTTPValidationError;

export function useGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Product Deletion Impact
 */

export function useGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProductDeletionImpactApiV1MasterDataProductsProductsProductIdDeletionImpactGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bulk-set product status, over an explicit id list or the whole filter set.

``match_all_filtered`` resolves the SAME filtered query the list page renders
(``build_product_list_filters``) to a bounded id set, then hands it to the
same set-based service method the id path uses — so the two cannot drift and
the audit trail is identical. Bounded by ``BULK_MATCHING_MAX_AFFECTED``;
over that the call is refused rather than truncated.
 * @summary Bulk Update Products
 */
export const bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost = (
  bulkProductUpdateRequest: BulkProductUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products/bulk-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkProductUpdateRequest,
    signal
  });
};

export const getBulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost
        >
      >,
      TError,
      { data: BulkProductUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost
      >
    >,
    TError,
    { data: BulkProductUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost
        >
      >,
      { data: BulkProductUpdateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost
      >
    >
  >;
export type BulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePostMutationBody =
  BulkProductUpdateRequest;
export type BulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Update Products
 */
export const useBulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost
          >
        >,
        TError,
        { data: BulkProductUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePost
      >
    >,
    TError,
    { data: BulkProductUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkUpdateProductsApiV1MasterDataProductsProductsBulkUpdatePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Bulk delete products. Max 100 items.
 * @summary Bulk Delete Products
 */
export const bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost = (
  bulkProductRequest: BulkProductRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/products/bulk-delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkProductRequest,
    signal
  });
};

export const getBulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost
        >
      >,
      TError,
      { data: BulkProductRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost
      >
    >,
    TError,
    { data: BulkProductRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost
        >
      >,
      { data: BulkProductRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost
      >
    >
  >;
export type BulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePostMutationBody =
  BulkProductRequest;
export type BulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Delete Products
 */
export const useBulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost
          >
        >,
        TError,
        { data: BulkProductRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePost
      >
    >,
    TError,
    { data: BulkProductRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkDeleteProductsApiV1MasterDataProductsProductsBulkDeletePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Archive a product.
 * @summary Archive Product
 */
export const archiveProductApiV1MasterDataProductsProductsProductIdArchivePost =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/archive`,
      method: 'POST',
      signal
    });
  };

export const getArchiveProductApiV1MasterDataProductsProductsProductIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveProductApiV1MasterDataProductsProductsProductIdArchivePost
        >
      >,
      TError,
      { productId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveProductApiV1MasterDataProductsProductsProductIdArchivePost
      >
    >,
    TError,
    { productId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveProductApiV1MasterDataProductsProductsProductIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveProductApiV1MasterDataProductsProductsProductIdArchivePost
        >
      >,
      { productId: string }
    > = (props) => {
      const { productId } = props ?? {};

      return archiveProductApiV1MasterDataProductsProductsProductIdArchivePost(
        productId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveProductApiV1MasterDataProductsProductsProductIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveProductApiV1MasterDataProductsProductsProductIdArchivePost
      >
    >
  >;

export type ArchiveProductApiV1MasterDataProductsProductsProductIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Product
 */
export const useArchiveProductApiV1MasterDataProductsProductsProductIdArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof archiveProductApiV1MasterDataProductsProductsProductIdArchivePost
          >
        >,
        TError,
        { productId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof archiveProductApiV1MasterDataProductsProductsProductIdArchivePost
      >
    >,
    TError,
    { productId: string },
    TContext
  > => {
    const mutationOptions =
      getArchiveProductApiV1MasterDataProductsProductsProductIdArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Un-soft-delete a product within the grace window (deletion-and-cascade-design
§4.1). Clears deleted_at only — the product returns to the archived state it was
hidden in, so it does not silently reappear in active catalogs; the owner
unarchives it to bring it back into use. Cascaded pricing/tags/external keys are
not resurrected.
 * @summary Restore Product
 */
export const restoreProductApiV1MasterDataProductsProductsProductIdRestorePost =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/restore`,
      method: 'POST',
      signal
    });
  };

export const getRestoreProductApiV1MasterDataProductsProductsProductIdRestorePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof restoreProductApiV1MasterDataProductsProductsProductIdRestorePost
        >
      >,
      TError,
      { productId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof restoreProductApiV1MasterDataProductsProductsProductIdRestorePost
      >
    >,
    TError,
    { productId: string },
    TContext
  > => {
    const mutationKey = [
      'restoreProductApiV1MasterDataProductsProductsProductIdRestorePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof restoreProductApiV1MasterDataProductsProductsProductIdRestorePost
        >
      >,
      { productId: string }
    > = (props) => {
      const { productId } = props ?? {};

      return restoreProductApiV1MasterDataProductsProductsProductIdRestorePost(
        productId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RestoreProductApiV1MasterDataProductsProductsProductIdRestorePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof restoreProductApiV1MasterDataProductsProductsProductIdRestorePost
      >
    >
  >;

export type RestoreProductApiV1MasterDataProductsProductsProductIdRestorePostMutationError =
  HTTPValidationError;

/**
 * @summary Restore Product
 */
export const useRestoreProductApiV1MasterDataProductsProductsProductIdRestorePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof restoreProductApiV1MasterDataProductsProductsProductIdRestorePost
          >
        >,
        TError,
        { productId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof restoreProductApiV1MasterDataProductsProductsProductIdRestorePost
      >
    >,
    TError,
    { productId: string },
    TContext
  > => {
    const mutationOptions =
      getRestoreProductApiV1MasterDataProductsProductsProductIdRestorePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all variants for a product.
 * @summary List Variants
 */
export const listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet = (
  productId: string,
  signal?: AbortSignal
) => {
  return customInstance<ProductVariantListResponse>({
    url: `/api/v1/master-data/products/products/${productId}/variants`,
    method: 'GET',
    signal
  });
};

export const getListVariantsApiV1MasterDataProductsProductsProductIdVariantsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/variants`
    ] as const;
  };

export const getListVariantsApiV1MasterDataProductsProductsProductIdVariantsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListVariantsApiV1MasterDataProductsProductsProductIdVariantsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
        >
      >
    > = ({ signal }) =>
      listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListVariantsApiV1MasterDataProductsProductsProductIdVariantsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
      >
    >
  >;
export type ListVariantsApiV1MasterDataProductsProductsProductIdVariantsGetQueryError =
  HTTPValidationError;

export function useListVariantsApiV1MasterDataProductsProductsProductIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListVariantsApiV1MasterDataProductsProductsProductIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListVariantsApiV1MasterDataProductsProductsProductIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Variants
 */

export function useListVariantsApiV1MasterDataProductsProductsProductIdVariantsGet<
  TData = Awaited<
    ReturnType<
      typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariantsApiV1MasterDataProductsProductsProductIdVariantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListVariantsApiV1MasterDataProductsProductsProductIdVariantsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a single product variant from a selected dimension-value combination.
 * @summary Create Variant
 */
export const createVariantApiV1MasterDataProductsProductsProductIdVariantsPost =
  (
    productId: string,
    productVariantRequest: ProductVariantRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ProductVariantResponse>({
      url: `/api/v1/master-data/products/products/${productId}/variants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productVariantRequest,
      signal
    });
  };

export const getCreateVariantApiV1MasterDataProductsProductsProductIdVariantsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createVariantApiV1MasterDataProductsProductsProductIdVariantsPost
        >
      >,
      TError,
      { productId: string; data: ProductVariantRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createVariantApiV1MasterDataProductsProductsProductIdVariantsPost
      >
    >,
    TError,
    { productId: string; data: ProductVariantRequest },
    TContext
  > => {
    const mutationKey = [
      'createVariantApiV1MasterDataProductsProductsProductIdVariantsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createVariantApiV1MasterDataProductsProductsProductIdVariantsPost
        >
      >,
      { productId: string; data: ProductVariantRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createVariantApiV1MasterDataProductsProductsProductIdVariantsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateVariantApiV1MasterDataProductsProductsProductIdVariantsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createVariantApiV1MasterDataProductsProductsProductIdVariantsPost
      >
    >
  >;
export type CreateVariantApiV1MasterDataProductsProductsProductIdVariantsPostMutationBody =
  ProductVariantRequest;
export type CreateVariantApiV1MasterDataProductsProductsProductIdVariantsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Variant
 */
export const useCreateVariantApiV1MasterDataProductsProductsProductIdVariantsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createVariantApiV1MasterDataProductsProductsProductIdVariantsPost
          >
        >,
        TError,
        { productId: string; data: ProductVariantRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createVariantApiV1MasterDataProductsProductsProductIdVariantsPost
      >
    >,
    TError,
    { productId: string; data: ProductVariantRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateVariantApiV1MasterDataProductsProductsProductIdVariantsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Create a named SKU sibling (a variant with no dimension axes).

The flat-variant counterpart of ``create_variant`` — see
docs/modules/master-data/flat-variant-design.md. Rejected when the product
already has variant dimensions: a product is either purely dimensional or
purely flat.
 * @summary Create Flat Variant
 */
export const createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost =
  (
    productId: string,
    productVariantFlatCreate: ProductVariantFlatCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<ProductVariantResponse>({
      url: `/api/v1/master-data/products/products/${productId}/variants/flat`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productVariantFlatCreate,
      signal
    });
  };

export const getCreateFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost
        >
      >,
      TError,
      { productId: string; data: ProductVariantFlatCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost
      >
    >,
    TError,
    { productId: string; data: ProductVariantFlatCreate },
    TContext
  > => {
    const mutationKey = [
      'createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost
        >
      >,
      { productId: string; data: ProductVariantFlatCreate }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost
      >
    >
  >;
export type CreateFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPostMutationBody =
  ProductVariantFlatCreate;
export type CreateFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Flat Variant
 */
export const useCreateFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost
          >
        >,
        TError,
        { productId: string; data: ProductVariantFlatCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPost
      >
    >,
    TError,
    { productId: string; data: ProductVariantFlatCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateFlatVariantApiV1MasterDataProductsProductsProductIdVariantsFlatPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Batch-create variants from a set of dimension-value combinations.
 * @summary Generate Variants
 */
export const generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost =
  (
    productId: string,
    variantGenerateRequest: VariantGenerateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ProductVariantListResponse>({
      url: `/api/v1/master-data/products/products/${productId}/variants/generate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: variantGenerateRequest,
      signal
    });
  };

export const getGenerateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost
        >
      >,
      TError,
      { productId: string; data: VariantGenerateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost
      >
    >,
    TError,
    { productId: string; data: VariantGenerateRequest },
    TContext
  > => {
    const mutationKey = [
      'generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost
        >
      >,
      { productId: string; data: VariantGenerateRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost
      >
    >
  >;
export type GenerateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePostMutationBody =
  VariantGenerateRequest;
export type GenerateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Variants
 */
export const useGenerateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost
          >
        >,
        TError,
        { productId: string; data: VariantGenerateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePost
      >
    >,
    TError,
    { productId: string; data: VariantGenerateRequest },
    TContext
  > => {
    const mutationOptions =
      getGenerateVariantsApiV1MasterDataProductsProductsProductIdVariantsGeneratePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Resolve a variant for a dimension-value combination, creating it on first use.

Idempotent: the same combination always returns the same variant. This is
the lazy-materialization path — a variant row is created on demand rather
than eagerly via the matrix generator.
 * @summary Resolve Variant
 */
export const resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost =
  (
    productId: string,
    variantResolveRequest: VariantResolveRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ProductVariantResponse>({
      url: `/api/v1/master-data/products/products/${productId}/variants/resolve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: variantResolveRequest,
      signal
    });
  };

export const getResolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost
        >
      >,
      TError,
      { productId: string; data: VariantResolveRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost
      >
    >,
    TError,
    { productId: string; data: VariantResolveRequest },
    TContext
  > => {
    const mutationKey = [
      'resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost
        >
      >,
      { productId: string; data: VariantResolveRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost
      >
    >
  >;
export type ResolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePostMutationBody =
  VariantResolveRequest;
export type ResolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Variant
 */
export const useResolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost
          >
        >,
        TError,
        { productId: string; data: VariantResolveRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePost
      >
    >,
    TError,
    { productId: string; data: VariantResolveRequest },
    TContext
  > => {
    const mutationOptions =
      getResolveVariantApiV1MasterDataProductsProductsProductIdVariantsResolvePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a product variant's name, SKU, status or dimension overrides.
 * @summary Update Variant
 */
export const updateVariantApiV1MasterDataProductsVariantsVariantIdPut = (
  variantId: string,
  productVariantRequest: ProductVariantRequest
) => {
  return customInstance<ProductVariantResponse>({
    url: `/api/v1/master-data/products/variants/${variantId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: productVariantRequest
  });
};

export const getUpdateVariantApiV1MasterDataProductsVariantsVariantIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateVariantApiV1MasterDataProductsVariantsVariantIdPut
        >
      >,
      TError,
      { variantId: string; data: ProductVariantRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateVariantApiV1MasterDataProductsVariantsVariantIdPut
      >
    >,
    TError,
    { variantId: string; data: ProductVariantRequest },
    TContext
  > => {
    const mutationKey = [
      'updateVariantApiV1MasterDataProductsVariantsVariantIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateVariantApiV1MasterDataProductsVariantsVariantIdPut
        >
      >,
      { variantId: string; data: ProductVariantRequest }
    > = (props) => {
      const { variantId, data } = props ?? {};

      return updateVariantApiV1MasterDataProductsVariantsVariantIdPut(
        variantId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateVariantApiV1MasterDataProductsVariantsVariantIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateVariantApiV1MasterDataProductsVariantsVariantIdPut
      >
    >
  >;
export type UpdateVariantApiV1MasterDataProductsVariantsVariantIdPutMutationBody =
  ProductVariantRequest;
export type UpdateVariantApiV1MasterDataProductsVariantsVariantIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Variant
 */
export const useUpdateVariantApiV1MasterDataProductsVariantsVariantIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateVariantApiV1MasterDataProductsVariantsVariantIdPut
        >
      >,
      TError,
      { variantId: string; data: ProductVariantRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateVariantApiV1MasterDataProductsVariantsVariantIdPut>
  >,
  TError,
  { variantId: string; data: ProductVariantRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateVariantApiV1MasterDataProductsVariantsVariantIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a product variant.
 * @summary Delete Variant
 */
export const deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete = (
  variantId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/variants/${variantId}`,
    method: 'DELETE'
  });
};

export const getDeleteVariantApiV1MasterDataProductsVariantsVariantIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete
        >
      >,
      TError,
      { variantId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete
      >
    >,
    TError,
    { variantId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete
        >
      >,
      { variantId: string }
    > = (props) => {
      const { variantId } = props ?? {};

      return deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete(
        variantId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteVariantApiV1MasterDataProductsVariantsVariantIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete
      >
    >
  >;

export type DeleteVariantApiV1MasterDataProductsVariantsVariantIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Variant
 */
export const useDeleteVariantApiV1MasterDataProductsVariantsVariantIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete
        >
      >,
      TError,
      { variantId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteVariantApiV1MasterDataProductsVariantsVariantIdDelete
    >
  >,
  TError,
  { variantId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteVariantApiV1MasterDataProductsVariantsVariantIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List the tenant's reusable variant-dimension library templates.
 * @summary List Dimension Library
 */
export const listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/dimension-library`,
    method: 'GET',
    signal
  });
};

export const getListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/dimension-library`] as const;
  };

export const getListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
        >
      >
    > = ({ signal }) =>
      listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
      >
    >
  >;
export type ListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGetQueryError =
  unknown;

export function useListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dimension Library
 */

export function useListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet<
  TData = Awaited<
    ReturnType<
      typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDimensionLibraryApiV1MasterDataProductsDimensionLibraryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDimensionLibraryApiV1MasterDataProductsDimensionLibraryGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a reusable library dimension.
 * @summary Create Library Dimension
 */
export const createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost =
  (dimensionRequest: DimensionRequest, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/dimension-library`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionRequest,
      signal
    });
  };

export const getCreateLibraryDimensionApiV1MasterDataProductsDimensionLibraryPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost
        >
      >,
      TError,
      { data: DimensionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost
      >
    >,
    TError,
    { data: DimensionRequest },
    TContext
  > => {
    const mutationKey = [
      'createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost
        >
      >,
      { data: DimensionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLibraryDimensionApiV1MasterDataProductsDimensionLibraryPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost
      >
    >
  >;
export type CreateLibraryDimensionApiV1MasterDataProductsDimensionLibraryPostMutationBody =
  DimensionRequest;
export type CreateLibraryDimensionApiV1MasterDataProductsDimensionLibraryPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Library Dimension
 */
export const useCreateLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost
          >
        >,
        TError,
        { data: DimensionRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createLibraryDimensionApiV1MasterDataProductsDimensionLibraryPost
      >
    >,
    TError,
    { data: DimensionRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateLibraryDimensionApiV1MasterDataProductsDimensionLibraryPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a product's variant dimensions.
 * @summary List Product Dimensions
 */
export const listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/dimensions`,
      method: 'GET',
      signal
    });
  };

export const getListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/dimensions`
    ] as const;
  };

export const getListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
        >
      >
    > = ({ signal }) =>
      listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
      >
    >
  >;
export type ListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGetQueryError =
  HTTPValidationError;

export function useListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Product Dimensions
 */

export function useListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductDimensionsApiV1MasterDataProductsProductsProductIdDimensionsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a product-scoped variant dimension.
 * @summary Create Product Dimension
 */
export const createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost =
  (
    productId: string,
    dimensionRequest: DimensionRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/dimensions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionRequest,
      signal
    });
  };

export const getCreateProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost
        >
      >,
      TError,
      { productId: string; data: DimensionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost
      >
    >,
    TError,
    { productId: string; data: DimensionRequest },
    TContext
  > => {
    const mutationKey = [
      'createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost
        >
      >,
      { productId: string; data: DimensionRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost
      >
    >
  >;
export type CreateProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPostMutationBody =
  DimensionRequest;
export type CreateProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Product Dimension
 */
export const useCreateProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost
          >
        >,
        TError,
        { productId: string; data: DimensionRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPost
      >
    >,
    TError,
    { productId: string; data: DimensionRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateProductDimensionApiV1MasterDataProductsProductsProductIdDimensionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Copy a library dimension onto a product (copy-on-attach).
 * @summary Attach Library Dimension
 */
export const attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost =
  (
    productId: string,
    attachDimensionRequest: AttachDimensionRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/dimensions/attach`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: attachDimensionRequest,
      signal
    });
  };

export const getAttachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost
        >
      >,
      TError,
      { productId: string; data: AttachDimensionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost
      >
    >,
    TError,
    { productId: string; data: AttachDimensionRequest },
    TContext
  > => {
    const mutationKey = [
      'attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost
        >
      >,
      { productId: string; data: AttachDimensionRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AttachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost
      >
    >
  >;
export type AttachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPostMutationBody =
  AttachDimensionRequest;
export type AttachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPostMutationError =
  HTTPValidationError;

/**
 * @summary Attach Library Dimension
 */
export const useAttachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost
          >
        >,
        TError,
        { productId: string; data: AttachDimensionRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof attachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPost
      >
    >,
    TError,
    { productId: string; data: AttachDimensionRequest },
    TContext
  > => {
    const mutationOptions =
      getAttachLibraryDimensionApiV1MasterDataProductsProductsProductIdDimensionsAttachPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Rename or reorder a dimension (library or product-scoped).
 * @summary Update Dimension
 */
export const updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut = (
  dimensionId: string,
  dimensionUpdateRequest: DimensionUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/dimensions/${dimensionId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dimensionUpdateRequest
  });
};

export const getUpdateDimensionApiV1MasterDataProductsDimensionsDimensionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut
        >
      >,
      TError,
      { dimensionId: string; data: DimensionUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut
      >
    >,
    TError,
    { dimensionId: string; data: DimensionUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut
        >
      >,
      { dimensionId: string; data: DimensionUpdateRequest }
    > = (props) => {
      const { dimensionId, data } = props ?? {};

      return updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut(
        dimensionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDimensionApiV1MasterDataProductsDimensionsDimensionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut
      >
    >
  >;
export type UpdateDimensionApiV1MasterDataProductsDimensionsDimensionIdPutMutationBody =
  DimensionUpdateRequest;
export type UpdateDimensionApiV1MasterDataProductsDimensionsDimensionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dimension
 */
export const useUpdateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut
          >
        >,
        TError,
        { dimensionId: string; data: DimensionUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDimensionApiV1MasterDataProductsDimensionsDimensionIdPut
      >
    >,
    TError,
    { dimensionId: string; data: DimensionUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateDimensionApiV1MasterDataProductsDimensionsDimensionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a dimension. Blocked if existing variants depend on it.
 * @summary Delete Dimension
 */
export const deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete =
  (dimensionId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/dimensions/${dimensionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete
        >
      >,
      TError,
      { dimensionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete
      >
    >,
    TError,
    { dimensionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete
        >
      >,
      { dimensionId: string }
    > = (props) => {
      const { dimensionId } = props ?? {};

      return deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete(
        dimensionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete
      >
    >
  >;

export type DeleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dimension
 */
export const useDeleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete
          >
        >,
        TError,
        { dimensionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDelete
      >
    >,
    TError,
    { dimensionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDimensionApiV1MasterDataProductsDimensionsDimensionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add an allowed value to a dimension.
 * @summary Add Dimension Value
 */
export const addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost =
  (
    dimensionId: string,
    dimensionValueRequest: DimensionValueRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/dimensions/${dimensionId}/values`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionValueRequest,
      signal
    });
  };

export const getAddDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost
        >
      >,
      TError,
      { dimensionId: string; data: DimensionValueRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost
      >
    >,
    TError,
    { dimensionId: string; data: DimensionValueRequest },
    TContext
  > => {
    const mutationKey = [
      'addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost
        >
      >,
      { dimensionId: string; data: DimensionValueRequest }
    > = (props) => {
      const { dimensionId, data } = props ?? {};

      return addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost(
        dimensionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost
      >
    >
  >;
export type AddDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPostMutationBody =
  DimensionValueRequest;
export type AddDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Dimension Value
 */
export const useAddDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost
          >
        >,
        TError,
        { dimensionId: string; data: DimensionValueRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPost
      >
    >,
    TError,
    { dimensionId: string; data: DimensionValueRequest },
    TContext
  > => {
    const mutationOptions =
      getAddDimensionValueApiV1MasterDataProductsDimensionsDimensionIdValuesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a dimension value's label, SKU code or order.
 * @summary Update Dimension Value
 */
export const updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut =
  (
    valueId: string,
    dimensionValueUpdateRequest: DimensionValueUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/dimension-values/${valueId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dimensionValueUpdateRequest
    });
  };

export const getUpdateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut
        >
      >,
      TError,
      { valueId: string; data: DimensionValueUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut
      >
    >,
    TError,
    { valueId: string; data: DimensionValueUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut
        >
      >,
      { valueId: string; data: DimensionValueUpdateRequest }
    > = (props) => {
      const { valueId, data } = props ?? {};

      return updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut(
        valueId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut
      >
    >
  >;
export type UpdateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPutMutationBody =
  DimensionValueUpdateRequest;
export type UpdateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dimension Value
 */
export const useUpdateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut
          >
        >,
        TError,
        { valueId: string; data: DimensionValueUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPut
      >
    >,
    TError,
    { valueId: string; data: DimensionValueUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateDimensionValueApiV1MasterDataProductsDimensionValuesValueIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a dimension value. Blocked if existing variants use it.
 * @summary Delete Dimension Value
 */
export const deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete =
  (valueId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/dimension-values/${valueId}`,
      method: 'DELETE'
    });
  };

export const getDeleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete
        >
      >,
      TError,
      { valueId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete
      >
    >,
    TError,
    { valueId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete
        >
      >,
      { valueId: string }
    > = (props) => {
      const { valueId } = props ?? {};

      return deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete(
        valueId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete
      >
    >
  >;

export type DeleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dimension Value
 */
export const useDeleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete
          >
        >,
        TError,
        { valueId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDelete
      >
    >,
    TError,
    { valueId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDimensionValueApiV1MasterDataProductsDimensionValuesValueIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a product's **effective** configurations — its own fields plus those
inherited (read-only) from its categories and their ancestors. Each entry
carries ``is_inherited`` + ``inherited_from_category_id/name`` so the editor
can render inherited configs greyed and non-editable.
 * @summary List Configurations
 */
export const listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/configurations`,
      method: 'GET',
      signal
    });
  };

export const getListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/configurations`
    ] as const;
  };

export const getListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
        >
      >
    > = ({ signal }) =>
      listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
      >
    >
  >;
export type ListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGetQueryError =
  HTTPValidationError;

export function useListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Configurations
 */

export function useListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListConfigurationsApiV1MasterDataProductsProductsProductIdConfigurationsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a configuration on a product.
 * @summary Create Configuration
 */
export const createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost =
  (
    productId: string,
    configurationRequest: ConfigurationRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/configurations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: configurationRequest,
      signal
    });
  };

export const getCreateConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost
        >
      >,
      TError,
      { productId: string; data: ConfigurationRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost
      >
    >,
    TError,
    { productId: string; data: ConfigurationRequest },
    TContext
  > => {
    const mutationKey = [
      'createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost
        >
      >,
      { productId: string; data: ConfigurationRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost
      >
    >
  >;
export type CreateConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPostMutationBody =
  ConfigurationRequest;
export type CreateConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Configuration
 */
export const useCreateConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost
          >
        >,
        TError,
        { productId: string; data: ConfigurationRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPost
      >
    >,
    TError,
    { productId: string; data: ConfigurationRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateConfigurationApiV1MasterDataProductsProductsProductIdConfigurationsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a configuration's definition (name, type, inventory_tracked, pricing).
 * @summary Update Configuration
 */
export const updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut =
  (
    configurationId: string,
    configurationUpdateRequest: ConfigurationUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/configurations/${configurationId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: configurationUpdateRequest
    });
  };

export const getUpdateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut
        >
      >,
      TError,
      { configurationId: string; data: ConfigurationUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut
      >
    >,
    TError,
    { configurationId: string; data: ConfigurationUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut
        >
      >,
      { configurationId: string; data: ConfigurationUpdateRequest }
    > = (props) => {
      const { configurationId, data } = props ?? {};

      return updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut(
        configurationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut
      >
    >
  >;
export type UpdateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPutMutationBody =
  ConfigurationUpdateRequest;
export type UpdateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Configuration
 */
export const useUpdateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut
          >
        >,
        TError,
        { configurationId: string; data: ConfigurationUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPut
      >
    >,
    TError,
    { configurationId: string; data: ConfigurationUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a configuration and its values.
 * @summary Delete Configuration
 */
export const deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete =
  (configurationId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/configurations/${configurationId}`,
      method: 'DELETE'
    });
  };

export const getDeleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete
        >
      >,
      TError,
      { configurationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete
      >
    >,
    TError,
    { configurationId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete
        >
      >,
      { configurationId: string }
    > = (props) => {
      const { configurationId } = props ?? {};

      return deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete(
        configurationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete
      >
    >
  >;

export type DeleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Configuration
 */
export const useDeleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete
          >
        >,
        TError,
        { configurationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDelete
      >
    >,
    TError,
    { configurationId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteConfigurationApiV1MasterDataProductsConfigurationsConfigurationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add an allowed value to a select / multi_select configuration.
 * @summary Add Configuration Value
 */
export const addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost =
  (
    configurationId: string,
    configurationValueRequest: ConfigurationValueRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/configurations/${configurationId}/values`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: configurationValueRequest,
      signal
    });
  };

export const getAddConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost
        >
      >,
      TError,
      { configurationId: string; data: ConfigurationValueRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost
      >
    >,
    TError,
    { configurationId: string; data: ConfigurationValueRequest },
    TContext
  > => {
    const mutationKey = [
      'addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost
        >
      >,
      { configurationId: string; data: ConfigurationValueRequest }
    > = (props) => {
      const { configurationId, data } = props ?? {};

      return addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost(
        configurationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost
      >
    >
  >;
export type AddConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPostMutationBody =
  ConfigurationValueRequest;
export type AddConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Configuration Value
 */
export const useAddConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost
          >
        >,
        TError,
        { configurationId: string; data: ConfigurationValueRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPost
      >
    >,
    TError,
    { configurationId: string; data: ConfigurationValueRequest },
    TContext
  > => {
    const mutationOptions =
      getAddConfigurationValueApiV1MasterDataProductsConfigurationsConfigurationIdValuesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a configuration value.
 * @summary Update Configuration Value
 */
export const updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut =
  (
    valueId: string,
    configurationValueUpdateRequest: ConfigurationValueUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/configuration-values/${valueId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: configurationValueUpdateRequest
    });
  };

export const getUpdateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut
        >
      >,
      TError,
      { valueId: string; data: ConfigurationValueUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut
      >
    >,
    TError,
    { valueId: string; data: ConfigurationValueUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut
        >
      >,
      { valueId: string; data: ConfigurationValueUpdateRequest }
    > = (props) => {
      const { valueId, data } = props ?? {};

      return updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut(
        valueId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut
      >
    >
  >;
export type UpdateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPutMutationBody =
  ConfigurationValueUpdateRequest;
export type UpdateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Configuration Value
 */
export const useUpdateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut
          >
        >,
        TError,
        { valueId: string; data: ConfigurationValueUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPut
      >
    >,
    TError,
    { valueId: string; data: ConfigurationValueUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a configuration value.
 * @summary Delete Configuration Value
 */
export const deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete =
  (valueId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/configuration-values/${valueId}`,
      method: 'DELETE'
    });
  };

export const getDeleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete
        >
      >,
      TError,
      { valueId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete
      >
    >,
    TError,
    { valueId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete
        >
      >,
      { valueId: string }
    > = (props) => {
      const { valueId } = props ?? {};

      return deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete(
        valueId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete
      >
    >
  >;

export type DeleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Configuration Value
 */
export const useDeleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete
          >
        >,
        TError,
        { valueId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDelete
      >
    >,
    TError,
    { valueId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteConfigurationValueApiV1MasterDataProductsConfigurationValuesValueIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a category's **effective** configurations — its own fields plus those
inherited (read-only) from ancestor categories. Each entry carries
``is_inherited`` + ``inherited_from_category_id/name``.
 * @summary List Category Configurations
 */
export const listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet =
  (categoryId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/categories/${categoryId}/configurations`,
      method: 'GET',
      signal
    });
  };

export const getListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGetQueryKey =
  (categoryId?: string) => {
    return [
      `/api/v1/master-data/products/categories/${categoryId}/configurations`
    ] as const;
  };

export const getListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    categoryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGetQueryKey(
        categoryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
        >
      >
    > = ({ signal }) =>
      listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet(
        categoryId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!categoryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
      >
    >
  >;
export type ListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGetQueryError =
  HTTPValidationError;

export function useListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Category Configurations
 */

export function useListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCategoryConfigurationsApiV1MasterDataProductsCategoriesCategoryIdConfigurationsGetQueryOptions(
      categoryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a configuration owned by a category (inherited by subcategories +
products).
 * @summary Create Category Configuration
 */
export const createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost =
  (
    categoryId: string,
    configurationRequest: ConfigurationRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/categories/${categoryId}/configurations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: configurationRequest,
      signal
    });
  };

export const getCreateCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost
        >
      >,
      TError,
      { categoryId: string; data: ConfigurationRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost
      >
    >,
    TError,
    { categoryId: string; data: ConfigurationRequest },
    TContext
  > => {
    const mutationKey = [
      'createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost
        >
      >,
      { categoryId: string; data: ConfigurationRequest }
    > = (props) => {
      const { categoryId, data } = props ?? {};

      return createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost(
        categoryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost
      >
    >
  >;
export type CreateCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPostMutationBody =
  ConfigurationRequest;
export type CreateCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Category Configuration
 */
export const useCreateCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost
          >
        >,
        TError,
        { categoryId: string; data: ConfigurationRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPost
      >
    >,
    TError,
    { categoryId: string; data: ConfigurationRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateCategoryConfigurationApiV1MasterDataProductsCategoriesCategoryIdConfigurationsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List every price list entry for a product across all (non-archived) price lists.

Powers the Pricing tab on Product detail.
 * @summary List Product Price List Entries
 */
export const listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/price-list-entries`,
      method: 'GET',
      signal
    });
  };

export const getListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/price-list-entries`
    ] as const;
  };

export const getListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
        >
      >
    > = ({ signal }) =>
      listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
      >
    >
  >;
export type ListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGetQueryError =
  HTTPValidationError;

export function useListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Product Price List Entries
 */

export function useListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductPriceListEntriesApiV1MasterDataProductsProductsProductIdPriceListEntriesGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List packagings for a product.
 * @summary List Packagings
 */
export const listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/packagings`,
      method: 'GET',
      signal
    });
  };

export const getListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/packagings`
    ] as const;
  };

export const getListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
        >
      >
    > = ({ signal }) =>
      listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
      >
    >
  >;
export type ListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGetQueryError =
  HTTPValidationError;

export function useListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet<
  TData = Awaited<
    ReturnType<
      typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet<
  TData = Awaited<
    ReturnType<
      typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet<
  TData = Awaited<
    ReturnType<
      typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Packagings
 */

export function useListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet<
  TData = Awaited<
    ReturnType<
      typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPackagingsApiV1MasterDataProductsProductsProductIdPackagingsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a packaging for a product.
 * @summary Create Packaging
 */
export const createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost =
  (
    productId: string,
    productPackagingCreateRequest: ProductPackagingCreateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/packagings`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productPackagingCreateRequest,
      signal
    });
  };

export const getCreatePackagingApiV1MasterDataProductsProductsProductIdPackagingsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost
        >
      >,
      TError,
      { productId: string; data: ProductPackagingCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost
      >
    >,
    TError,
    { productId: string; data: ProductPackagingCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost
        >
      >,
      { productId: string; data: ProductPackagingCreateRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePackagingApiV1MasterDataProductsProductsProductIdPackagingsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost
      >
    >
  >;
export type CreatePackagingApiV1MasterDataProductsProductsProductIdPackagingsPostMutationBody =
  ProductPackagingCreateRequest;
export type CreatePackagingApiV1MasterDataProductsProductsProductIdPackagingsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Packaging
 */
export const useCreatePackagingApiV1MasterDataProductsProductsProductIdPackagingsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost
          >
        >,
        TError,
        { productId: string; data: ProductPackagingCreateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createPackagingApiV1MasterDataProductsProductsProductIdPackagingsPost
      >
    >,
    TError,
    { productId: string; data: ProductPackagingCreateRequest },
    TContext
  > => {
    const mutationOptions =
      getCreatePackagingApiV1MasterDataProductsProductsProductIdPackagingsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a packaging.
 * @summary Update Packaging
 */
export const updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut = (
  packagingId: string,
  productPackagingUpdateRequest: ProductPackagingUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/packagings/${packagingId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: productPackagingUpdateRequest
  });
};

export const getUpdatePackagingApiV1MasterDataProductsPackagingsPackagingIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut
        >
      >,
      TError,
      { packagingId: string; data: ProductPackagingUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut
      >
    >,
    TError,
    { packagingId: string; data: ProductPackagingUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut
        >
      >,
      { packagingId: string; data: ProductPackagingUpdateRequest }
    > = (props) => {
      const { packagingId, data } = props ?? {};

      return updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut(
        packagingId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePackagingApiV1MasterDataProductsPackagingsPackagingIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut
      >
    >
  >;
export type UpdatePackagingApiV1MasterDataProductsPackagingsPackagingIdPutMutationBody =
  ProductPackagingUpdateRequest;
export type UpdatePackagingApiV1MasterDataProductsPackagingsPackagingIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Packaging
 */
export const useUpdatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut
          >
        >,
        TError,
        { packagingId: string; data: ProductPackagingUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updatePackagingApiV1MasterDataProductsPackagingsPackagingIdPut
      >
    >,
    TError,
    { packagingId: string; data: ProductPackagingUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdatePackagingApiV1MasterDataProductsPackagingsPackagingIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a packaging. Rejected only if the packaging has stock on hand.
 * @summary Delete Packaging
 */
export const deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete =
  (packagingId: string) => {
    return customInstance<void>({
      url: `/api/v1/master-data/products/packagings/${packagingId}`,
      method: 'DELETE'
    });
  };

export const getDeletePackagingApiV1MasterDataProductsPackagingsPackagingIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete
        >
      >,
      TError,
      { packagingId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete
      >
    >,
    TError,
    { packagingId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete
        >
      >,
      { packagingId: string }
    > = (props) => {
      const { packagingId } = props ?? {};

      return deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete(
        packagingId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePackagingApiV1MasterDataProductsPackagingsPackagingIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete
      >
    >
  >;

export type DeletePackagingApiV1MasterDataProductsPackagingsPackagingIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Packaging
 */
export const useDeletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete
          >
        >,
        TError,
        { packagingId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deletePackagingApiV1MasterDataProductsPackagingsPackagingIdDelete
      >
    >,
    TError,
    { packagingId: string },
    TContext
  > => {
    const mutationOptions =
      getDeletePackagingApiV1MasterDataProductsPackagingsPackagingIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Set the product's default sales/purchase/stock packaging selections.

Only fields included in the request body are updated. Set a field to null
to clear it.
 * @summary Set Default Packagings
 */
export const setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut =
  (
    productId: string,
    productDefaultPackagingRequest: ProductDefaultPackagingRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/default-packagings`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: productDefaultPackagingRequest
    });
  };

export const getSetDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut
        >
      >,
      TError,
      { productId: string; data: ProductDefaultPackagingRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut
      >
    >,
    TError,
    { productId: string; data: ProductDefaultPackagingRequest },
    TContext
  > => {
    const mutationKey = [
      'setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut
        >
      >,
      { productId: string; data: ProductDefaultPackagingRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut
      >
    >
  >;
export type SetDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPutMutationBody =
  ProductDefaultPackagingRequest;
export type SetDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Default Packagings
 */
export const useSetDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut
          >
        >,
        TError,
        { productId: string; data: ProductDefaultPackagingRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPut
      >
    >,
    TError,
    { productId: string; data: ProductDefaultPackagingRequest },
    TContext
  > => {
    const mutationOptions =
      getSetDefaultPackagingsApiV1MasterDataProductsProductsProductIdDefaultPackagingsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all price lists.
 * @summary List Price Lists
 */
export const listPriceListsApiV1MasterDataProductsPriceListsGet = (
  params?: ListPriceListsApiV1MasterDataProductsPriceListsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/price-lists`,
    method: 'GET',
    params,
    signal
  });
};

export const getListPriceListsApiV1MasterDataProductsPriceListsGetQueryKey = (
  params?: ListPriceListsApiV1MasterDataProductsPriceListsGetParams
) => {
  return [
    `/api/v1/master-data/products/price-lists`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListPriceListsApiV1MasterDataProductsPriceListsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListPriceListsApiV1MasterDataProductsPriceListsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listPriceListsApiV1MasterDataProductsPriceListsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPriceListsApiV1MasterDataProductsPriceListsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
      >
    > = ({ signal }) =>
      listPriceListsApiV1MasterDataProductsPriceListsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListPriceListsApiV1MasterDataProductsPriceListsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
    >
  >;
export type ListPriceListsApiV1MasterDataProductsPriceListsGetQueryError =
  HTTPValidationError;

export function useListPriceListsApiV1MasterDataProductsPriceListsGet<
  TData = Awaited<
    ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListPriceListsApiV1MasterDataProductsPriceListsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPriceListsApiV1MasterDataProductsPriceListsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPriceListsApiV1MasterDataProductsPriceListsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPriceListsApiV1MasterDataProductsPriceListsGet<
  TData = Awaited<
    ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPriceListsApiV1MasterDataProductsPriceListsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPriceListsApiV1MasterDataProductsPriceListsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPriceListsApiV1MasterDataProductsPriceListsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPriceListsApiV1MasterDataProductsPriceListsGet<
  TData = Awaited<
    ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPriceListsApiV1MasterDataProductsPriceListsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Price Lists
 */

export function useListPriceListsApiV1MasterDataProductsPriceListsGet<
  TData = Awaited<
    ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPriceListsApiV1MasterDataProductsPriceListsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPriceListsApiV1MasterDataProductsPriceListsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPriceListsApiV1MasterDataProductsPriceListsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new price list.
 * @summary Create Price List
 */
export const createPriceListApiV1MasterDataProductsPriceListsPost = (
  priceListRequest: PriceListRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/price-lists`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: priceListRequest,
    signal
  });
};

export const getCreatePriceListApiV1MasterDataProductsPriceListsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPriceListApiV1MasterDataProductsPriceListsPost>
      >,
      TError,
      { data: PriceListRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createPriceListApiV1MasterDataProductsPriceListsPost>
    >,
    TError,
    { data: PriceListRequest },
    TContext
  > => {
    const mutationKey = [
      'createPriceListApiV1MasterDataProductsPriceListsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createPriceListApiV1MasterDataProductsPriceListsPost>
      >,
      { data: PriceListRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createPriceListApiV1MasterDataProductsPriceListsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePriceListApiV1MasterDataProductsPriceListsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createPriceListApiV1MasterDataProductsPriceListsPost>
    >
  >;
export type CreatePriceListApiV1MasterDataProductsPriceListsPostMutationBody =
  PriceListRequest;
export type CreatePriceListApiV1MasterDataProductsPriceListsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Price List
 */
export const useCreatePriceListApiV1MasterDataProductsPriceListsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPriceListApiV1MasterDataProductsPriceListsPost>
      >,
      TError,
      { data: PriceListRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createPriceListApiV1MasterDataProductsPriceListsPost>
  >,
  TError,
  { data: PriceListRequest },
  TContext
> => {
  const mutationOptions =
    getCreatePriceListApiV1MasterDataProductsPriceListsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a price list by ID.
 * @summary Get Price List
 */
export const getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet = (
  priceListId: string,
  params?: GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/price-lists/${priceListId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetQueryKey =
  (
    priceListId?: string,
    params?: GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams
  ) => {
    return [
      `/api/v1/master-data/products/price-lists/${priceListId}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    priceListId: string,
    params?: GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetQueryKey(
        priceListId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
        >
      >
    > = ({ signal }) =>
      getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet(
        priceListId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!priceListId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
      >
    >
  >;
export type GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetQueryError =
  HTTPValidationError;

export function useGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params:
    | undefined
    | GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params?: GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params?: GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Price List
 */

export function useGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params?: GetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPriceListApiV1MasterDataProductsPriceListsPriceListIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPriceListApiV1MasterDataProductsPriceListsPriceListIdGetQueryOptions(
      priceListId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a price list.

Partial: the inline-edit auto-save PUTs a single changed field, so only the
fields the caller explicitly set (``model_fields_set``) are applied — never
clobber the unsent ones (the bug that made every inline edit 400 on missing
name/currency).
 * @summary Update Price List
 */
export const updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut = (
  priceListId: string,
  priceListUpdateRequest: PriceListUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/price-lists/${priceListId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: priceListUpdateRequest
  });
};

export const getUpdatePriceListApiV1MasterDataProductsPriceListsPriceListIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut
        >
      >,
      TError,
      { priceListId: string; data: PriceListUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut
      >
    >,
    TError,
    { priceListId: string; data: PriceListUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut
        >
      >,
      { priceListId: string; data: PriceListUpdateRequest }
    > = (props) => {
      const { priceListId, data } = props ?? {};

      return updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut(
        priceListId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePriceListApiV1MasterDataProductsPriceListsPriceListIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut
      >
    >
  >;
export type UpdatePriceListApiV1MasterDataProductsPriceListsPriceListIdPutMutationBody =
  PriceListUpdateRequest;
export type UpdatePriceListApiV1MasterDataProductsPriceListsPriceListIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Price List
 */
export const useUpdatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut
          >
        >,
        TError,
        { priceListId: string; data: PriceListUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updatePriceListApiV1MasterDataProductsPriceListsPriceListIdPut
      >
    >,
    TError,
    { priceListId: string; data: PriceListUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdatePriceListApiV1MasterDataProductsPriceListsPriceListIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a price list.
 * @summary Delete Price List
 */
export const deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete =
  (priceListId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/price-lists/${priceListId}`,
      method: 'DELETE'
    });
  };

export const getDeletePriceListApiV1MasterDataProductsPriceListsPriceListIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete
        >
      >,
      TError,
      { priceListId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete
      >
    >,
    TError,
    { priceListId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete
        >
      >,
      { priceListId: string }
    > = (props) => {
      const { priceListId } = props ?? {};

      return deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete(
        priceListId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePriceListApiV1MasterDataProductsPriceListsPriceListIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete
      >
    >
  >;

export type DeletePriceListApiV1MasterDataProductsPriceListsPriceListIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Price List
 */
export const useDeletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete
          >
        >,
        TError,
        { priceListId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deletePriceListApiV1MasterDataProductsPriceListsPriceListIdDelete
      >
    >,
    TError,
    { priceListId: string },
    TContext
  > => {
    const mutationOptions =
      getDeletePriceListApiV1MasterDataProductsPriceListsPriceListIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List entries in a price list.
 * @summary List Price List Entries
 */
export const listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet =
  (
    priceListId: string,
    params?: ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/price-lists/${priceListId}/entries`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetQueryKey =
  (
    priceListId?: string,
    params?: ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams
  ) => {
    return [
      `/api/v1/master-data/products/price-lists/${priceListId}/entries`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    priceListId: string,
    params?: ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetQueryKey(
        priceListId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
        >
      >
    > = ({ signal }) =>
      listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet(
        priceListId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!priceListId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
      >
    >
  >;
export type ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetQueryError =
  HTTPValidationError;

export function useListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params:
    | undefined
    | ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params?: ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params?: ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Price List Entries
 */

export function useListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params?: ListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesGetQueryOptions(
      priceListId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a product to a price list.
 * @summary Create Price List Entry
 */
export const createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost =
  (
    priceListId: string,
    priceListEntryRequest: PriceListEntryRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/price-lists/${priceListId}/entries`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: priceListEntryRequest,
      signal
    });
  };

export const getCreatePriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost
        >
      >,
      TError,
      { priceListId: string; data: PriceListEntryRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost
      >
    >,
    TError,
    { priceListId: string; data: PriceListEntryRequest },
    TContext
  > => {
    const mutationKey = [
      'createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost
        >
      >,
      { priceListId: string; data: PriceListEntryRequest }
    > = (props) => {
      const { priceListId, data } = props ?? {};

      return createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost(
        priceListId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost
      >
    >
  >;
export type CreatePriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPostMutationBody =
  PriceListEntryRequest;
export type CreatePriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Price List Entry
 */
export const useCreatePriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost
          >
        >,
        TError,
        { priceListId: string; data: PriceListEntryRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createPriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPost
      >
    >,
    TError,
    { priceListId: string; data: PriceListEntryRequest },
    TContext
  > => {
    const mutationOptions =
      getCreatePriceListEntryApiV1MasterDataProductsPriceListsPriceListIdEntriesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a price list entry.
 * @summary Update Price List Entry
 */
export const updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut = (
  entryId: string,
  priceListEntryRequest: PriceListEntryRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/entries/${entryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: priceListEntryRequest
  });
};

export const getUpdatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut
        >
      >,
      TError,
      { entryId: string; data: PriceListEntryRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut
      >
    >,
    TError,
    { entryId: string; data: PriceListEntryRequest },
    TContext
  > => {
    const mutationKey = [
      'updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut
        >
      >,
      { entryId: string; data: PriceListEntryRequest }
    > = (props) => {
      const { entryId, data } = props ?? {};

      return updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut(
        entryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut
      >
    >
  >;
export type UpdatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPutMutationBody =
  PriceListEntryRequest;
export type UpdatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Price List Entry
 */
export const useUpdatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut
        >
      >,
      TError,
      { entryId: string; data: PriceListEntryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPut
    >
  >,
  TError,
  { entryId: string; data: PriceListEntryRequest },
  TContext
> => {
  const mutationOptions =
    getUpdatePriceListEntryApiV1MasterDataProductsEntriesEntryIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove a product from a price list.
 * @summary Delete Price List Entry
 */
export const deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete = (
  entryId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/entries/${entryId}`,
    method: 'DELETE'
  });
};

export const getDeletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete
        >
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete(
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete
      >
    >
  >;

export type DeletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Price List Entry
 */
export const useDeletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete
          >
        >,
        TError,
        { entryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDelete
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeletePriceListEntryApiV1MasterDataProductsEntriesEntryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Batch create/update/delete price list entries.
 * @summary Batch Update Price List Entries
 */
export const batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut =
  (priceListId: string, batchEntriesRequest: BatchEntriesRequest) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/price-lists/${priceListId}/entries/batch`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: batchEntriesRequest
    });
  };

export const getBatchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut
        >
      >,
      TError,
      { priceListId: string; data: BatchEntriesRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut
      >
    >,
    TError,
    { priceListId: string; data: BatchEntriesRequest },
    TContext
  > => {
    const mutationKey = [
      'batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut
        >
      >,
      { priceListId: string; data: BatchEntriesRequest }
    > = (props) => {
      const { priceListId, data } = props ?? {};

      return batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut(
        priceListId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BatchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut
      >
    >
  >;
export type BatchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPutMutationBody =
  BatchEntriesRequest;
export type BatchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPutMutationError =
  HTTPValidationError;

/**
 * @summary Batch Update Price List Entries
 */
export const useBatchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut
          >
        >,
        TError,
        { priceListId: string; data: BatchEntriesRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof batchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPut
      >
    >,
    TError,
    { priceListId: string; data: BatchEntriesRequest },
    TContext
  > => {
    const mutationOptions =
      getBatchUpdatePriceListEntriesApiV1MasterDataProductsPriceListsPriceListIdEntriesBatchPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all items in a bundle.
 * @summary List Bundle Items
 */
export const listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/bundle-items`,
      method: 'GET',
      signal
    });
  };

export const getListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/bundle-items`
    ] as const;
  };

export const getListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
        >
      >
    > = ({ signal }) =>
      listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
      >
    >
  >;
export type ListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGetQueryError =
  HTTPValidationError;

export function useListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Bundle Items
 */

export function useListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListBundleItemsApiV1MasterDataProductsProductsProductIdBundleItemsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an item to a bundle.
 * @summary Add Bundle Item
 */
export const addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost =
  (
    productId: string,
    bundleItemRequest: BundleItemRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/bundle-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bundleItemRequest,
      signal
    });
  };

export const getAddBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost
        >
      >,
      TError,
      { productId: string; data: BundleItemRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost
      >
    >,
    TError,
    { productId: string; data: BundleItemRequest },
    TContext
  > => {
    const mutationKey = [
      'addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost
        >
      >,
      { productId: string; data: BundleItemRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost
      >
    >
  >;
export type AddBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPostMutationBody =
  BundleItemRequest;
export type AddBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Bundle Item
 */
export const useAddBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost
          >
        >,
        TError,
        { productId: string; data: BundleItemRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPost
      >
    >,
    TError,
    { productId: string; data: BundleItemRequest },
    TContext
  > => {
    const mutationOptions =
      getAddBundleItemApiV1MasterDataProductsProductsProductIdBundleItemsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a bundle item.
 * @summary Update Bundle Item
 */
export const updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut = (
  itemId: string,
  bundleItemUpdateRequest: BundleItemUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/bundle-items/${itemId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: bundleItemUpdateRequest
  });
};

export const getUpdateBundleItemApiV1MasterDataProductsBundleItemsItemIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut
        >
      >,
      TError,
      { itemId: string; data: BundleItemUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut
      >
    >,
    TError,
    { itemId: string; data: BundleItemUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut
        >
      >,
      { itemId: string; data: BundleItemUpdateRequest }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateBundleItemApiV1MasterDataProductsBundleItemsItemIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut
      >
    >
  >;
export type UpdateBundleItemApiV1MasterDataProductsBundleItemsItemIdPutMutationBody =
  BundleItemUpdateRequest;
export type UpdateBundleItemApiV1MasterDataProductsBundleItemsItemIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Bundle Item
 */
export const useUpdateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut
        >
      >,
      TError,
      { itemId: string; data: BundleItemUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateBundleItemApiV1MasterDataProductsBundleItemsItemIdPut
    >
  >,
  TError,
  { itemId: string; data: BundleItemUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateBundleItemApiV1MasterDataProductsBundleItemsItemIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove an item from a bundle.
 * @summary Remove Bundle Item
 */
export const removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete = (
  itemId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/bundle-items/${itemId}`,
    method: 'DELETE'
  });
};

export const getRemoveBundleItemApiV1MasterDataProductsBundleItemsItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationKey = [
      'removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete
        >
      >,
      { itemId: string }
    > = (props) => {
      const { itemId } = props ?? {};

      return removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete(
        itemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveBundleItemApiV1MasterDataProductsBundleItemsItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete
      >
    >
  >;

export type RemoveBundleItemApiV1MasterDataProductsBundleItemsItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Bundle Item
 */
export const useRemoveBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete
          >
        >,
        TError,
        { itemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeBundleItemApiV1MasterDataProductsBundleItemsItemIdDelete
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveBundleItemApiV1MasterDataProductsBundleItemsItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all addons for a product.
 * @summary List Product Addons
 */
export const listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/addons`,
      method: 'GET',
      signal
    });
  };

export const getListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/addons`
    ] as const;
  };

export const getListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
        >
      >
    > = ({ signal }) =>
      listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
      >
    >
  >;
export type ListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGetQueryError =
  HTTPValidationError;

export function useListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Product Addons
 */

export function useListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductAddonsApiV1MasterDataProductsProductsProductIdAddonsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an addon to a product.
 * @summary Add Product Addon
 */
export const addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost =
  (
    productId: string,
    productAddonRequest: ProductAddonRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/addons`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productAddonRequest,
      signal
    });
  };

export const getAddProductAddonApiV1MasterDataProductsProductsProductIdAddonsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost
        >
      >,
      TError,
      { productId: string; data: ProductAddonRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost
      >
    >,
    TError,
    { productId: string; data: ProductAddonRequest },
    TContext
  > => {
    const mutationKey = [
      'addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost
        >
      >,
      { productId: string; data: ProductAddonRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddProductAddonApiV1MasterDataProductsProductsProductIdAddonsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost
      >
    >
  >;
export type AddProductAddonApiV1MasterDataProductsProductsProductIdAddonsPostMutationBody =
  ProductAddonRequest;
export type AddProductAddonApiV1MasterDataProductsProductsProductIdAddonsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Product Addon
 */
export const useAddProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost
          >
        >,
        TError,
        { productId: string; data: ProductAddonRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addProductAddonApiV1MasterDataProductsProductsProductIdAddonsPost
      >
    >,
    TError,
    { productId: string; data: ProductAddonRequest },
    TContext
  > => {
    const mutationOptions =
      getAddProductAddonApiV1MasterDataProductsProductsProductIdAddonsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove an addon from a product.
 * @summary Remove Product Addon
 */
export const removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete = (
  addonId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/addons/${addonId}`,
    method: 'DELETE'
  });
};

export const getRemoveProductAddonApiV1MasterDataProductsAddonsAddonIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete
        >
      >,
      TError,
      { addonId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete
      >
    >,
    TError,
    { addonId: string },
    TContext
  > => {
    const mutationKey = [
      'removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete
        >
      >,
      { addonId: string }
    > = (props) => {
      const { addonId } = props ?? {};

      return removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete(
        addonId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveProductAddonApiV1MasterDataProductsAddonsAddonIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete
      >
    >
  >;

export type RemoveProductAddonApiV1MasterDataProductsAddonsAddonIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Product Addon
 */
export const useRemoveProductAddonApiV1MasterDataProductsAddonsAddonIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete
        >
      >,
      TError,
      { addonId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof removeProductAddonApiV1MasterDataProductsAddonsAddonIdDelete
    >
  >,
  TError,
  { addonId: string },
  TContext
> => {
  const mutationOptions =
    getRemoveProductAddonApiV1MasterDataProductsAddonsAddonIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Resolve the unit price for a product / variant / packaging in a price list.

Catalog surface for the pricing UI. (Internal order pricing calls PricingService
directly at the service layer — §8 — never this gated route.)

Uses ``resolve_price`` (with packaging fallback): if no entry exists for the
requested packaging, falls back to the base-unit entry x ``quantity_in_base``.
Returns ``{"data": null}`` if no entry exists at all for the product.

Response shape:
    {
        "unit_price": number,  # DECIMAL dollars
        "source": "explicit" | "fallback",
        "entry": <price_list_entry dict>,
        "packaging_id": uuid | null
    }
 * @summary Get Product Price
 */
export const getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet =
  (
    priceListId: string,
    params: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/price-lists/${priceListId}/price`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetQueryKey =
  (
    priceListId?: string,
    params?: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams
  ) => {
    return [
      `/api/v1/master-data/products/price-lists/${priceListId}/price`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
      >
    >,
    TError = HTTPValidationError
  >(
    priceListId: string,
    params: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetQueryKey(
        priceListId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
        >
      >
    > = ({ signal }) =>
      getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet(
        priceListId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!priceListId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
      >
    >
  >;
export type GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetQueryError =
  HTTPValidationError;

export function useGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet<
  TData = Awaited<
    ReturnType<
      typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet<
  TData = Awaited<
    ReturnType<
      typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet<
  TData = Awaited<
    ReturnType<
      typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Product Price
 */

export function useGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet<
  TData = Awaited<
    ReturnType<
      typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
    >
  >,
  TError = HTTPValidationError
>(
  priceListId: string,
  params: GetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProductPriceApiV1MasterDataProductsPriceListsPriceListIdPriceGetQueryOptions(
      priceListId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Calculate the total price of a bundle.
 * @summary Get Bundle Price
 */
export const getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet =
  (
    productId: string,
    params?: GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/bundle-price`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetQueryKey =
  (
    productId?: string,
    params?: GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams
  ) => {
    return [
      `/api/v1/master-data/products/products/${productId}/bundle-price`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    params?: GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetQueryKey(
        productId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
        >
      >
    > = ({ signal }) =>
      getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet(
        productId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
      >
    >
  >;
export type GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetQueryError =
  HTTPValidationError;

export function useGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet<
  TData = Awaited<
    ReturnType<
      typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params:
    | undefined
    | GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet<
  TData = Awaited<
    ReturnType<
      typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet<
  TData = Awaited<
    ReturnType<
      typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bundle Price
 */

export function useGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet<
  TData = Awaited<
    ReturnType<
      typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  params?: GetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBundlePriceApiV1MasterDataProductsProductsProductIdBundlePriceGetQueryOptions(
      productId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all country-specific HS codes for a product.
 * @summary List Product Hs Codes
 */
export const listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/hs-codes`,
      method: 'GET',
      signal
    });
  };

export const getListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/hs-codes`
    ] as const;
  };

export const getListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
        >
      >
    > = ({ signal }) =>
      listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
      >
    >
  >;
export type ListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGetQueryError =
  HTTPValidationError;

export function useListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Product Hs Codes
 */

export function useListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet<
  TData = Awaited<
    ReturnType<
      typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductHsCodesApiV1MasterDataProductsProductsProductIdHsCodesGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a country-specific HS code to a product.
 * @summary Create Product Hs Code
 */
export const createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost =
  (
    productId: string,
    productHsCodeRequest: ProductHsCodeRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/hs-codes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productHsCodeRequest,
      signal
    });
  };

export const getCreateProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost
        >
      >,
      TError,
      { productId: string; data: ProductHsCodeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost
      >
    >,
    TError,
    { productId: string; data: ProductHsCodeRequest },
    TContext
  > => {
    const mutationKey = [
      'createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost
        >
      >,
      { productId: string; data: ProductHsCodeRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost
      >
    >
  >;
export type CreateProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPostMutationBody =
  ProductHsCodeRequest;
export type CreateProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Product Hs Code
 */
export const useCreateProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost
          >
        >,
        TError,
        { productId: string; data: ProductHsCodeRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPost
      >
    >,
    TError,
    { productId: string; data: ProductHsCodeRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateProductHsCodeApiV1MasterDataProductsProductsProductIdHsCodesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a product HS code.
 * @summary Update Product Hs Code
 */
export const updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut = (
  hsCodeId: string,
  productHsCodeRequest: ProductHsCodeRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/hs-codes/${hsCodeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: productHsCodeRequest
  });
};

export const getUpdateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut
        >
      >,
      TError,
      { hsCodeId: string; data: ProductHsCodeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut
      >
    >,
    TError,
    { hsCodeId: string; data: ProductHsCodeRequest },
    TContext
  > => {
    const mutationKey = [
      'updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut
        >
      >,
      { hsCodeId: string; data: ProductHsCodeRequest }
    > = (props) => {
      const { hsCodeId, data } = props ?? {};

      return updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut(
        hsCodeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut
      >
    >
  >;
export type UpdateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPutMutationBody =
  ProductHsCodeRequest;
export type UpdateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Product Hs Code
 */
export const useUpdateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut
        >
      >,
      TError,
      { hsCodeId: string; data: ProductHsCodeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPut
    >
  >,
  TError,
  { hsCodeId: string; data: ProductHsCodeRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a product HS code.
 * @summary Delete Product Hs Code
 */
export const deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete = (
  hsCodeId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/hs-codes/${hsCodeId}`,
    method: 'DELETE'
  });
};

export const getDeleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete
        >
      >,
      TError,
      { hsCodeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete
      >
    >,
    TError,
    { hsCodeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete
        >
      >,
      { hsCodeId: string }
    > = (props) => {
      const { hsCodeId } = props ?? {};

      return deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete(
        hsCodeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete
      >
    >
  >;

export type DeleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Product Hs Code
 */
export const useDeleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete
          >
        >,
        TError,
        { hsCodeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDelete
      >
    >,
    TError,
    { hsCodeId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteProductHsCodeApiV1MasterDataProductsHsCodesHsCodeIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Expand a batch of ProductReferences into display/pricing/stock data.

The single canonical resolver: every consuming module gets identical
display names, effective SKUs and unit prices. Pass ``price_list_id`` to
resolve catalog prices; omit it for label-only resolution.
 * @summary Resolve Product References
 */
export const resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost =
  (
    productReferenceResolveRequest: ProductReferenceResolveRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/product-references/resolve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productReferenceResolveRequest,
      signal
    });
  };

export const getResolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost
        >
      >,
      TError,
      { data: ProductReferenceResolveRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost
      >
    >,
    TError,
    { data: ProductReferenceResolveRequest },
    TContext
  > => {
    const mutationKey = [
      'resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost
        >
      >,
      { data: ProductReferenceResolveRequest }
    > = (props) => {
      const { data } = props ?? {};

      return resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost
      >
    >
  >;
export type ResolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePostMutationBody =
  ProductReferenceResolveRequest;
export type ResolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Product References
 */
export const useResolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost
          >
        >,
        TError,
        { data: ProductReferenceResolveRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePost
      >
    >,
    TError,
    { data: ProductReferenceResolveRequest },
    TContext
  > => {
    const mutationOptions =
      getResolveProductReferencesApiV1MasterDataProductsProductReferencesResolvePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Batch-load the picker sub-layers for a whole document's lines in ONE request.

``ProductReferencePicker`` renders once per line and each instance used to own
five queries — the product, its packagings, its variant dimensions, its
variants and its effective configurations. Those go out in PARALLEL and each
holds a request-pool connection for its whole handler duration, so a 21-line
quote demanded 105 connections from a pool whose production ceiling is 15
(`.claude/rules/rules-frontend.md` § "A component rendered ONCE PER CATALOG
ENTRY must not own its own query"). This is the one endpoint over the whole
set; the per-product routes stay for a picker mounted on its own.

Each array carries exactly what its per-product sibling returns, so a batched
picker and a standalone one render identically.

Sharing Contract C (batch gate): the per-product routes hide a product the
caller may not view behind a 404, so the batched twin drops it from the
response — no entry, rather than empty layers, so a caller can tell "not
yours" from "no packagings". ``everyone`` mode / tenant admins are unfiltered,
byte-identical to today.
 * @summary Load Product Catalog Layers
 */
export const loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost =
  (
    productCatalogLayersRequest: ProductCatalogLayersRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ProductCatalogLayersResponse>({
      url: `/api/v1/master-data/products/product-catalog-layers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productCatalogLayersRequest,
      signal
    });
  };

export const getLoadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost
        >
      >,
      TError,
      { data: ProductCatalogLayersRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost
      >
    >,
    TError,
    { data: ProductCatalogLayersRequest },
    TContext
  > => {
    const mutationKey = [
      'loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost
        >
      >,
      { data: ProductCatalogLayersRequest }
    > = (props) => {
      const { data } = props ?? {};

      return loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LoadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost
      >
    >
  >;
export type LoadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPostMutationBody =
  ProductCatalogLayersRequest;
export type LoadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPostMutationError =
  HTTPValidationError;

/**
 * @summary Load Product Catalog Layers
 */
export const useLoadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost
          >
        >,
        TError,
        { data: ProductCatalogLayersRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof loadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPost
      >
    >,
    TError,
    { data: ProductCatalogLayersRequest },
    TContext
  > => {
    const mutationOptions =
      getLoadProductCatalogLayersApiV1MasterDataProductsProductCatalogLayersPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all vendor SKUs for a product.
 * @summary List Product Vendor Skus
 */
export const listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<ProductVendorSku[]>({
      url: `/api/v1/master-data/products/products/${productId}/vendor-skus`,
      method: 'GET',
      signal
    });
  };

export const getListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/vendor-skus`
    ] as const;
  };

export const getListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
        >
      >
    > = ({ signal }) =>
      listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
      >
    >
  >;
export type ListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGetQueryError =
  HTTPValidationError;

export function useListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet<
  TData = Awaited<
    ReturnType<
      typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet<
  TData = Awaited<
    ReturnType<
      typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet<
  TData = Awaited<
    ReturnType<
      typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Product Vendor Skus
 */

export function useListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet<
  TData = Awaited<
    ReturnType<
      typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductVendorSkusApiV1MasterDataProductsProductsProductIdVendorSkusGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a vendor SKU to a product.
 * @summary Create Product Vendor Sku
 */
export const createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost =
  (
    productId: string,
    productVendorSkuRequest: ProductVendorSkuRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/vendor-skus`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productVendorSkuRequest,
      signal
    });
  };

export const getCreateProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost
        >
      >,
      TError,
      { productId: string; data: ProductVendorSkuRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost
      >
    >,
    TError,
    { productId: string; data: ProductVendorSkuRequest },
    TContext
  > => {
    const mutationKey = [
      'createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost
        >
      >,
      { productId: string; data: ProductVendorSkuRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost
      >
    >
  >;
export type CreateProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPostMutationBody =
  ProductVendorSkuRequest;
export type CreateProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Product Vendor Sku
 */
export const useCreateProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost
          >
        >,
        TError,
        { productId: string; data: ProductVendorSkuRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPost
      >
    >,
    TError,
    { productId: string; data: ProductVendorSkuRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateProductVendorSkuApiV1MasterDataProductsProductsProductIdVendorSkusPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the products a vendor offers (reciprocal of a product's vendor SKUs).

Powers the procurement vendor-profile Products tab.
 * @summary List Products By Vendor
 */
export const listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet =
  (
    vendorOrganizationId: string,
    params?: ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<VendorProductOffering[]>({
      url: `/api/v1/master-data/products/vendor-skus/by-vendor/${vendorOrganizationId}`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetQueryKey =
  (
    vendorOrganizationId?: string,
    params?: ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams
  ) => {
    return [
      `/api/v1/master-data/products/vendor-skus/by-vendor/${vendorOrganizationId}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    vendorOrganizationId: string,
    params?: ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetQueryKey(
        vendorOrganizationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
        >
      >
    > = ({ signal }) =>
      listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet(
        vendorOrganizationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!vendorOrganizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
      >
    >
  >;
export type ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetQueryError =
  HTTPValidationError;

export function useListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  params:
    | undefined
    | ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  params?: ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  params?: ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Products By Vendor
 */

export function useListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  params?: ListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductsByVendorApiV1MasterDataProductsVendorSkusByVendorVendorOrganizationIdGetQueryOptions(
      vendorOrganizationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a product vendor SKU.
 * @summary Update Product Vendor Sku
 */
export const updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut =
  (
    vendorSkuId: string,
    productVendorSkuUpdateRequest: ProductVendorSkuUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/vendor-skus/${vendorSkuId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: productVendorSkuUpdateRequest
    });
  };

export const getUpdateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut
        >
      >,
      TError,
      { vendorSkuId: string; data: ProductVendorSkuUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut
      >
    >,
    TError,
    { vendorSkuId: string; data: ProductVendorSkuUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut
        >
      >,
      { vendorSkuId: string; data: ProductVendorSkuUpdateRequest }
    > = (props) => {
      const { vendorSkuId, data } = props ?? {};

      return updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut(
        vendorSkuId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut
      >
    >
  >;
export type UpdateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPutMutationBody =
  ProductVendorSkuUpdateRequest;
export type UpdateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Product Vendor Sku
 */
export const useUpdateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut
          >
        >,
        TError,
        { vendorSkuId: string; data: ProductVendorSkuUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPut
      >
    >,
    TError,
    { vendorSkuId: string; data: ProductVendorSkuUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a product vendor SKU.
 * @summary Delete Product Vendor Sku
 */
export const deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete =
  (vendorSkuId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/vendor-skus/${vendorSkuId}`,
      method: 'DELETE'
    });
  };

export const getDeleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete
        >
      >,
      TError,
      { vendorSkuId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete
      >
    >,
    TError,
    { vendorSkuId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete
        >
      >,
      { vendorSkuId: string }
    > = (props) => {
      const { vendorSkuId } = props ?? {};

      return deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete(
        vendorSkuId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete
      >
    >
  >;

export type DeleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Product Vendor Sku
 */
export const useDeleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete
          >
        >,
        TError,
        { vendorSkuId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDelete
      >
    >,
    TError,
    { vendorSkuId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteProductVendorSkuApiV1MasterDataProductsVendorSkusVendorSkuIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the product categories a vendor is explicitly tagged as sourcing.

Powers the vendor-detail "Sourcing coverage" tab (the edit surface — explicit
tags only, inheritance not expanded). Batch-loaded, no N+1.
 * @summary List Vendor Category Coverage
 */
export const listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet =
  (vendorOrganizationId: string, signal?: AbortSignal) => {
    return customInstance<VendorCategoryCoverage[]>({
      url: `/api/v1/master-data/products/vendors/${vendorOrganizationId}/category-coverage`,
      method: 'GET',
      signal
    });
  };

export const getListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGetQueryKey =
  (vendorOrganizationId?: string) => {
    return [
      `/api/v1/master-data/products/vendors/${vendorOrganizationId}/category-coverage`
    ] as const;
  };

export const getListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
      >
    >,
    TError = HTTPValidationError
  >(
    vendorOrganizationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGetQueryKey(
        vendorOrganizationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
        >
      >
    > = ({ signal }) =>
      listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet(
        vendorOrganizationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!vendorOrganizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
      >
    >
  >;
export type ListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGetQueryError =
  HTTPValidationError;

export function useListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Vendor Category Coverage
 */

export function useListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  vendorOrganizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageGetQueryOptions(
      vendorOrganizationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Tag a vendor as sourcing a product category.
 * @summary Add Vendor Category Coverage
 */
export const addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost =
  (
    vendorOrganizationId: string,
    vendorCategoryCoverageCreate: VendorCategoryCoverageCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<VendorCategoryCoverageResponse>({
      url: `/api/v1/master-data/products/vendors/${vendorOrganizationId}/category-coverage`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: vendorCategoryCoverageCreate,
      signal
    });
  };

export const getAddVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost
        >
      >,
      TError,
      { vendorOrganizationId: string; data: VendorCategoryCoverageCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost
      >
    >,
    TError,
    { vendorOrganizationId: string; data: VendorCategoryCoverageCreate },
    TContext
  > => {
    const mutationKey = [
      'addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost
        >
      >,
      { vendorOrganizationId: string; data: VendorCategoryCoverageCreate }
    > = (props) => {
      const { vendorOrganizationId, data } = props ?? {};

      return addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost(
        vendorOrganizationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost
      >
    >
  >;
export type AddVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePostMutationBody =
  VendorCategoryCoverageCreate;
export type AddVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePostMutationError =
  HTTPValidationError;

/**
 * @summary Add Vendor Category Coverage
 */
export const useAddVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost
          >
        >,
        TError,
        { vendorOrganizationId: string; data: VendorCategoryCoverageCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePost
      >
    >,
    TError,
    { vendorOrganizationId: string; data: VendorCategoryCoverageCreate },
    TContext
  > => {
    const mutationOptions =
      getAddVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoveragePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the vendors that cover a product category (reciprocal direction).

Includes vendors tagged directly on the category and those inherited from an
ancestor category (``is_inherited=true``). Batch-loaded, no N+1.
 * @summary List Category Vendors
 */
export const listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet =
  (categoryId: string, signal?: AbortSignal) => {
    return customInstance<CategoryVendorCoverage[]>({
      url: `/api/v1/master-data/products/categories/${categoryId}/vendors`,
      method: 'GET',
      signal
    });
  };

export const getListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGetQueryKey =
  (categoryId?: string) => {
    return [
      `/api/v1/master-data/products/categories/${categoryId}/vendors`
    ] as const;
  };

export const getListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
      >
    >,
    TError = HTTPValidationError
  >(
    categoryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGetQueryKey(
        categoryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
        >
      >
    > = ({ signal }) =>
      listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet(
        categoryId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!categoryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
      >
    >
  >;
export type ListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGetQueryError =
  HTTPValidationError;

export function useListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Category Vendors
 */

export function useListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
    >
  >,
  TError = HTTPValidationError
>(
  categoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCategoryVendorsApiV1MasterDataProductsCategoriesCategoryIdVendorsGetQueryOptions(
      categoryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resolved coverage for the requested RFQ categories, including ancestor
tags. Bounded to the categories the supplier picker actually needs.
 * @summary Get Category Vendor Coverage Map
 */
export const getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet =
  (
    params: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<CategoryCoverageEntry[]>({
      url: `/api/v1/master-data/products/product-category-vendors/coverage`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetQueryKey =
  (
    params?: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams
  ) => {
    return [
      `/api/v1/master-data/products/product-category-vendors/coverage`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
        >
      >
    > = ({ signal }) =>
      getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
      >
    >
  >;
export type GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetQueryError =
  HTTPValidationError;

export function useGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Category Vendor Coverage Map
 */

export function useGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet<
  TData = Awaited<
    ReturnType<
      typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
    >
  >,
  TError = HTTPValidationError
>(
  params: GetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCategoryVendorCoverageMapApiV1MasterDataProductsProductCategoryVendorsCoverageGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the preferred flag / notes on a vendor's category coverage.
 * @summary Update Vendor Category Coverage
 */
export const updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut =
  (
    vendorOrganizationId: string,
    productCategoryId: string,
    vendorCategoryCoverageUpdate: VendorCategoryCoverageUpdate
  ) => {
    return customInstance<VendorCategoryCoverageResponse>({
      url: `/api/v1/master-data/products/vendors/${vendorOrganizationId}/category-coverage/${productCategoryId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: vendorCategoryCoverageUpdate
    });
  };

export const getUpdateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut
        >
      >,
      TError,
      {
        vendorOrganizationId: string;
        productCategoryId: string;
        data: VendorCategoryCoverageUpdate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut
      >
    >,
    TError,
    {
      vendorOrganizationId: string;
      productCategoryId: string;
      data: VendorCategoryCoverageUpdate;
    },
    TContext
  > => {
    const mutationKey = [
      'updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut
        >
      >,
      {
        vendorOrganizationId: string;
        productCategoryId: string;
        data: VendorCategoryCoverageUpdate;
      }
    > = (props) => {
      const { vendorOrganizationId, productCategoryId, data } = props ?? {};

      return updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut(
        vendorOrganizationId,
        productCategoryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut
      >
    >
  >;
export type UpdateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPutMutationBody =
  VendorCategoryCoverageUpdate;
export type UpdateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Vendor Category Coverage
 */
export const useUpdateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut
          >
        >,
        TError,
        {
          vendorOrganizationId: string;
          productCategoryId: string;
          data: VendorCategoryCoverageUpdate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPut
      >
    >,
    TError,
    {
      vendorOrganizationId: string;
      productCategoryId: string;
      data: VendorCategoryCoverageUpdate;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a vendor's coverage of a product category.
 * @summary Delete Vendor Category Coverage
 */
export const deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete =
  (vendorOrganizationId: string, productCategoryId: string) => {
    return customInstance<VendorCategoryCoverageDeleteResult>({
      url: `/api/v1/master-data/products/vendors/${vendorOrganizationId}/category-coverage/${productCategoryId}`,
      method: 'DELETE'
    });
  };

export const getDeleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete
        >
      >,
      TError,
      { vendorOrganizationId: string; productCategoryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete
      >
    >,
    TError,
    { vendorOrganizationId: string; productCategoryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete
        >
      >,
      { vendorOrganizationId: string; productCategoryId: string }
    > = (props) => {
      const { vendorOrganizationId, productCategoryId } = props ?? {};

      return deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete(
        vendorOrganizationId,
        productCategoryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete
      >
    >
  >;

export type DeleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Vendor Category Coverage
 */
export const useDeleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete
          >
        >,
        TError,
        { vendorOrganizationId: string; productCategoryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDelete
      >
    >,
    TError,
    { vendorOrganizationId: string; productCategoryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteVendorCategoryCoverageApiV1MasterDataProductsVendorsVendorOrganizationIdCategoryCoverageProductCategoryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all per-warehouse GL account overrides for a product.
 * @summary List Product Warehouse Accounts
 */
export const listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet =
  (productId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/warehouse-accounts`,
      method: 'GET',
      signal
    });
  };

export const getListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGetQueryKey =
  (productId?: string) => {
    return [
      `/api/v1/master-data/products/products/${productId}/warehouse-accounts`
    ] as const;
  };

export const getListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
      >
    >,
    TError = HTTPValidationError
  >(
    productId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGetQueryKey(
        productId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
        >
      >
    > = ({ signal }) =>
      listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet(
        productId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!productId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
      >
    >
  >;
export type ListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGetQueryError =
  HTTPValidationError;

export function useListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Product Warehouse Accounts
 */

export function useListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet<
  TData = Awaited<
    ReturnType<
      typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
    >
  >,
  TError = HTTPValidationError
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProductWarehouseAccountsApiV1MasterDataProductsProductsProductIdWarehouseAccountsGetQueryOptions(
      productId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a per-warehouse GL account override to a product.
 * @summary Create Product Warehouse Account
 */
export const createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost =
  (
    productId: string,
    productWarehouseAccountRequest: ProductWarehouseAccountRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/products/${productId}/warehouse-accounts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: productWarehouseAccountRequest,
      signal
    });
  };

export const getCreateProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost
        >
      >,
      TError,
      { productId: string; data: ProductWarehouseAccountRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost
      >
    >,
    TError,
    { productId: string; data: ProductWarehouseAccountRequest },
    TContext
  > => {
    const mutationKey = [
      'createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost
        >
      >,
      { productId: string; data: ProductWarehouseAccountRequest }
    > = (props) => {
      const { productId, data } = props ?? {};

      return createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost(
        productId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost
      >
    >
  >;
export type CreateProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPostMutationBody =
  ProductWarehouseAccountRequest;
export type CreateProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Product Warehouse Account
 */
export const useCreateProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost
          >
        >,
        TError,
        { productId: string; data: ProductWarehouseAccountRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPost
      >
    >,
    TError,
    { productId: string; data: ProductWarehouseAccountRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateProductWarehouseAccountApiV1MasterDataProductsProductsProductIdWarehouseAccountsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a per-warehouse GL account override.
 * @summary Update Product Warehouse Account
 */
export const updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut =
  (
    accountId: string,
    productWarehouseAccountUpdateRequest: ProductWarehouseAccountUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/warehouse-accounts/${accountId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: productWarehouseAccountUpdateRequest
    });
  };

export const getUpdateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut
        >
      >,
      TError,
      { accountId: string; data: ProductWarehouseAccountUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut
      >
    >,
    TError,
    { accountId: string; data: ProductWarehouseAccountUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut
        >
      >,
      { accountId: string; data: ProductWarehouseAccountUpdateRequest }
    > = (props) => {
      const { accountId, data } = props ?? {};

      return updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut(
        accountId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut
      >
    >
  >;
export type UpdateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPutMutationBody =
  ProductWarehouseAccountUpdateRequest;
export type UpdateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Product Warehouse Account
 */
export const useUpdateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut
          >
        >,
        TError,
        { accountId: string; data: ProductWarehouseAccountUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPut
      >
    >,
    TError,
    { accountId: string; data: ProductWarehouseAccountUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a per-warehouse GL account override.
 * @summary Delete Product Warehouse Account
 */
export const deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete =
  (accountId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/warehouse-accounts/${accountId}`,
      method: 'DELETE'
    });
  };

export const getDeleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete
        >
      >,
      TError,
      { accountId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete
      >
    >,
    TError,
    { accountId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete
        >
      >,
      { accountId: string }
    > = (props) => {
      const { accountId } = props ?? {};

      return deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete(
        accountId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete
      >
    >
  >;

export type DeleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Product Warehouse Account
 */
export const useDeleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete
          >
        >,
        TError,
        { accountId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDelete
      >
    >,
    TError,
    { accountId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteProductWarehouseAccountApiV1MasterDataProductsWarehouseAccountsAccountIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Use AI to extract product details from a product-page URL.

Returns an SSE stream with progress events:
  step=fetching → step=analyzing → step=done (with data)
 * @summary Enrich Product From Url
 */
export const enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost = (
  productUrlEnrichmentRequest: ProductUrlEnrichmentRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/enrich-from-url`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: productUrlEnrichmentRequest,
    signal
  });
};

export const getEnrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost
        >
      >,
      TError,
      { data: ProductUrlEnrichmentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost
      >
    >,
    TError,
    { data: ProductUrlEnrichmentRequest },
    TContext
  > => {
    const mutationKey = [
      'enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost
        >
      >,
      { data: ProductUrlEnrichmentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost
      >
    >
  >;
export type EnrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPostMutationBody =
  ProductUrlEnrichmentRequest;
export type EnrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPostMutationError =
  HTTPValidationError;

/**
 * @summary Enrich Product From Url
 */
export const useEnrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost
        >
      >,
      TError,
      { data: ProductUrlEnrichmentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof enrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPost
    >
  >,
  TError,
  { data: ProductUrlEnrichmentRequest },
  TContext
> => {
  const mutationOptions =
    getEnrichProductFromUrlApiV1MasterDataProductsEnrichFromUrlPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Parse the file and return its columns + a sample for column mapping.

``has_header`` false parses a headerless export (a legacy ERP dump whose
column names live in a separate spec document): row 1 is data and the columns
come back as positional ``Column 1…N`` names to map. The run endpoint must be
given the same flag, or it would parse a different column set than was mapped.
 * @summary Preview Catalog Import
 */
export const previewCatalogImport = (
  bodyPreviewCatalogImport: BodyPreviewCatalogImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyPreviewCatalogImport.data_file);
  if (bodyPreviewCatalogImport.has_header !== undefined) {
    formData.append(
      `has_header`,
      bodyPreviewCatalogImport.has_header.toString()
    );
  }

  return customInstance<CatalogImportPreviewResponse>({
    url: `/api/v1/master-data/products/catalog-import/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getPreviewCatalogImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewCatalogImport>>,
    TError,
    { data: BodyPreviewCatalogImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewCatalogImport>>,
  TError,
  { data: BodyPreviewCatalogImport },
  TContext
> => {
  const mutationKey = ['previewCatalogImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewCatalogImport>>,
    { data: BodyPreviewCatalogImport }
  > = (props) => {
    const { data } = props ?? {};

    return previewCatalogImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewCatalogImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewCatalogImport>>
>;
export type PreviewCatalogImportMutationBody = BodyPreviewCatalogImport;
export type PreviewCatalogImportMutationError = HTTPValidationError;

/**
 * @summary Preview Catalog Import
 */
export const usePreviewCatalogImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewCatalogImport>>,
      TError,
      { data: BodyPreviewCatalogImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewCatalogImport>>,
  TError,
  { data: BodyPreviewCatalogImport },
  TContext
> => {
  const mutationOptions = getPreviewCatalogImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Check every unit of the file against the database. Writes nothing.

The wizard's Validation and Reconciliation steps both render off this one
response, so the two screens cannot disagree about a number. Re-called
whenever a per-row decision changes, because a decision moves the totals.

``preset_key`` names a registered format, whose parser reads the file's fixed
columns — so the caller sends no column mapping at all, which is the whole
point of a preset. Anything else is graded against the reviewer's own
mapping, and ``has_header`` must repeat what the preview was given.

The same ids the run gates are gated here, and for the same reason: this
endpoint reads the chosen price list and names the destination warehouse, and
both arrive in the request body.
 * @summary Plan Catalog Import
 */
export const planCatalogImport = (
  bodyPlanCatalogImport: BodyPlanCatalogImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyPlanCatalogImport.data_file);
  if (
    bodyPlanCatalogImport.preset_key !== undefined &&
    bodyPlanCatalogImport.preset_key !== null
  ) {
    formData.append(`preset_key`, bodyPlanCatalogImport.preset_key);
  }
  if (
    bodyPlanCatalogImport.sku_column !== undefined &&
    bodyPlanCatalogImport.sku_column !== null
  ) {
    formData.append(`sku_column`, bodyPlanCatalogImport.sku_column);
  }
  if (bodyPlanCatalogImport.axis_columns !== undefined) {
    bodyPlanCatalogImport.axis_columns.forEach((value) =>
      formData.append(`axis_columns`, value)
    );
  }
  if (
    bodyPlanCatalogImport.name_column !== undefined &&
    bodyPlanCatalogImport.name_column !== null
  ) {
    formData.append(`name_column`, bodyPlanCatalogImport.name_column);
  }
  if (
    bodyPlanCatalogImport.description_column !== undefined &&
    bodyPlanCatalogImport.description_column !== null
  ) {
    formData.append(
      `description_column`,
      bodyPlanCatalogImport.description_column
    );
  }
  if (
    bodyPlanCatalogImport.variant_sku_column !== undefined &&
    bodyPlanCatalogImport.variant_sku_column !== null
  ) {
    formData.append(
      `variant_sku_column`,
      bodyPlanCatalogImport.variant_sku_column
    );
  }
  if (
    bodyPlanCatalogImport.price_column !== undefined &&
    bodyPlanCatalogImport.price_column !== null
  ) {
    formData.append(`price_column`, bodyPlanCatalogImport.price_column);
  }
  if (
    bodyPlanCatalogImport.price_list_id !== undefined &&
    bodyPlanCatalogImport.price_list_id !== null
  ) {
    formData.append(`price_list_id`, bodyPlanCatalogImport.price_list_id);
  }
  if (
    bodyPlanCatalogImport.image_url_column !== undefined &&
    bodyPlanCatalogImport.image_url_column !== null
  ) {
    formData.append(`image_url_column`, bodyPlanCatalogImport.image_url_column);
  }
  if (
    bodyPlanCatalogImport.quantity_column !== undefined &&
    bodyPlanCatalogImport.quantity_column !== null
  ) {
    formData.append(`quantity_column`, bodyPlanCatalogImport.quantity_column);
  }
  if (
    bodyPlanCatalogImport.bin_location_column !== undefined &&
    bodyPlanCatalogImport.bin_location_column !== null
  ) {
    formData.append(
      `bin_location_column`,
      bodyPlanCatalogImport.bin_location_column
    );
  }
  if (
    bodyPlanCatalogImport.warehouse_id !== undefined &&
    bodyPlanCatalogImport.warehouse_id !== null
  ) {
    formData.append(`warehouse_id`, bodyPlanCatalogImport.warehouse_id);
  }
  if (
    bodyPlanCatalogImport.company_id !== undefined &&
    bodyPlanCatalogImport.company_id !== null
  ) {
    formData.append(`company_id`, bodyPlanCatalogImport.company_id);
  }
  if (bodyPlanCatalogImport.has_header !== undefined) {
    formData.append(`has_header`, bodyPlanCatalogImport.has_header.toString());
  }
  if (bodyPlanCatalogImport.decision_row_indexes !== undefined) {
    bodyPlanCatalogImport.decision_row_indexes.forEach((value) =>
      formData.append(`decision_row_indexes`, value.toString())
    );
  }
  if (bodyPlanCatalogImport.decision_options !== undefined) {
    bodyPlanCatalogImport.decision_options.forEach((value) =>
      formData.append(`decision_options`, value)
    );
  }

  return customInstance<CatalogImportPlanResponse>({
    url: `/api/v1/master-data/products/catalog-import/plan`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getPlanCatalogImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planCatalogImport>>,
    TError,
    { data: BodyPlanCatalogImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planCatalogImport>>,
  TError,
  { data: BodyPlanCatalogImport },
  TContext
> => {
  const mutationKey = ['planCatalogImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planCatalogImport>>,
    { data: BodyPlanCatalogImport }
  > = (props) => {
    const { data } = props ?? {};

    return planCatalogImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanCatalogImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof planCatalogImport>>
>;
export type PlanCatalogImportMutationBody = BodyPlanCatalogImport;
export type PlanCatalogImportMutationError = HTTPValidationError;

/**
 * @summary Plan Catalog Import
 */
export const usePlanCatalogImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof planCatalogImport>>,
      TError,
      { data: BodyPlanCatalogImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof planCatalogImport>>,
  TError,
  { data: BodyPlanCatalogImport },
  TContext
> => {
  const mutationOptions = getPlanCatalogImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Import the catalogue file with the user's column mapping.

``price_list_id`` is the destination for mapped prices (its currency wins);
omit it to skip price import. ``tag_names`` are free-text tags applied to
every imported product. ``has_header`` must repeat what the preview was given,
since the mapping names the columns that parse produced.

``quantity_column`` turns the file into a stock position: each row's figure is
the TARGET on-hand at ``warehouse_id`` (and ``bin_location_column``'s bin),
reconciled through the inventory module's stock service, so a re-import of an
unchanged file writes nothing. ``company_id`` is the legal entity the import is
for — it tags the products created, must be able to see the chosen price list,
and must own the chosen warehouse.
 * @summary Run Catalog Import
 */
export const runCatalogImport = (
  bodyRunCatalogImport: BodyRunCatalogImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyRunCatalogImport.data_file);
  formData.append(`sku_column`, bodyRunCatalogImport.sku_column);
  if (bodyRunCatalogImport.axis_columns !== undefined) {
    bodyRunCatalogImport.axis_columns.forEach((value) =>
      formData.append(`axis_columns`, value)
    );
  }
  if (
    bodyRunCatalogImport.name_column !== undefined &&
    bodyRunCatalogImport.name_column !== null
  ) {
    formData.append(`name_column`, bodyRunCatalogImport.name_column);
  }
  if (
    bodyRunCatalogImport.description_column !== undefined &&
    bodyRunCatalogImport.description_column !== null
  ) {
    formData.append(
      `description_column`,
      bodyRunCatalogImport.description_column
    );
  }
  if (
    bodyRunCatalogImport.variant_sku_column !== undefined &&
    bodyRunCatalogImport.variant_sku_column !== null
  ) {
    formData.append(
      `variant_sku_column`,
      bodyRunCatalogImport.variant_sku_column
    );
  }
  if (
    bodyRunCatalogImport.price_column !== undefined &&
    bodyRunCatalogImport.price_column !== null
  ) {
    formData.append(`price_column`, bodyRunCatalogImport.price_column);
  }
  if (
    bodyRunCatalogImport.price_list_id !== undefined &&
    bodyRunCatalogImport.price_list_id !== null
  ) {
    formData.append(`price_list_id`, bodyRunCatalogImport.price_list_id);
  }
  if (
    bodyRunCatalogImport.image_url_column !== undefined &&
    bodyRunCatalogImport.image_url_column !== null
  ) {
    formData.append(`image_url_column`, bodyRunCatalogImport.image_url_column);
  }
  if (
    bodyRunCatalogImport.quantity_column !== undefined &&
    bodyRunCatalogImport.quantity_column !== null
  ) {
    formData.append(`quantity_column`, bodyRunCatalogImport.quantity_column);
  }
  if (
    bodyRunCatalogImport.bin_location_column !== undefined &&
    bodyRunCatalogImport.bin_location_column !== null
  ) {
    formData.append(
      `bin_location_column`,
      bodyRunCatalogImport.bin_location_column
    );
  }
  if (
    bodyRunCatalogImport.warehouse_id !== undefined &&
    bodyRunCatalogImport.warehouse_id !== null
  ) {
    formData.append(`warehouse_id`, bodyRunCatalogImport.warehouse_id);
  }
  if (
    bodyRunCatalogImport.company_id !== undefined &&
    bodyRunCatalogImport.company_id !== null
  ) {
    formData.append(`company_id`, bodyRunCatalogImport.company_id);
  }
  if (bodyRunCatalogImport.tag_names !== undefined) {
    bodyRunCatalogImport.tag_names.forEach((value) =>
      formData.append(`tag_names`, value)
    );
  }
  if (bodyRunCatalogImport.has_header !== undefined) {
    formData.append(`has_header`, bodyRunCatalogImport.has_header.toString());
  }
  if (bodyRunCatalogImport.decision_row_indexes !== undefined) {
    bodyRunCatalogImport.decision_row_indexes.forEach((value) =>
      formData.append(`decision_row_indexes`, value.toString())
    );
  }
  if (bodyRunCatalogImport.decision_options !== undefined) {
    bodyRunCatalogImport.decision_options.forEach((value) =>
      formData.append(`decision_options`, value)
    );
  }

  return customInstance<CatalogImportResultResponse>({
    url: `/api/v1/master-data/products/catalog-import/run`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getRunCatalogImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCatalogImport>>,
    TError,
    { data: BodyRunCatalogImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runCatalogImport>>,
  TError,
  { data: BodyRunCatalogImport },
  TContext
> => {
  const mutationKey = ['runCatalogImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runCatalogImport>>,
    { data: BodyRunCatalogImport }
  > = (props) => {
    const { data } = props ?? {};

    return runCatalogImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunCatalogImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof runCatalogImport>>
>;
export type RunCatalogImportMutationBody = BodyRunCatalogImport;
export type RunCatalogImportMutationError = HTTPValidationError;

/**
 * @summary Run Catalog Import
 */
export const useRunCatalogImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runCatalogImport>>,
      TError,
      { data: BodyRunCatalogImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof runCatalogImport>>,
  TError,
  { data: BodyRunCatalogImport },
  TContext
> => {
  const mutationOptions = getRunCatalogImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Detect + summarise a known-format product export (e.g. Shopify) before running.

Preset formats have fixed columns, so there is no column-mapping step — this
returns a recognition flag plus product/variant/image counts for a
confirmation view.
 * @summary Preview Catalog Import Preset
 */
export const previewCatalogImportPreset = (
  presetKey: string,
  bodyPreviewCatalogImportPreset: BodyPreviewCatalogImportPreset,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyPreviewCatalogImportPreset.data_file);

  return customInstance<CatalogImportPresetPreviewResponse>({
    url: `/api/v1/master-data/products/catalog-import/preset/${presetKey}/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getPreviewCatalogImportPresetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewCatalogImportPreset>>,
    TError,
    { presetKey: string; data: BodyPreviewCatalogImportPreset },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewCatalogImportPreset>>,
  TError,
  { presetKey: string; data: BodyPreviewCatalogImportPreset },
  TContext
> => {
  const mutationKey = ['previewCatalogImportPreset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewCatalogImportPreset>>,
    { presetKey: string; data: BodyPreviewCatalogImportPreset }
  > = (props) => {
    const { presetKey, data } = props ?? {};

    return previewCatalogImportPreset(presetKey, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewCatalogImportPresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewCatalogImportPreset>>
>;
export type PreviewCatalogImportPresetMutationBody =
  BodyPreviewCatalogImportPreset;
export type PreviewCatalogImportPresetMutationError = HTTPValidationError;

/**
 * @summary Preview Catalog Import Preset
 */
export const usePreviewCatalogImportPreset = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewCatalogImportPreset>>,
      TError,
      { presetKey: string; data: BodyPreviewCatalogImportPreset },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewCatalogImportPreset>>,
  TError,
  { presetKey: string; data: BodyPreviewCatalogImportPreset },
  TContext
> => {
  const mutationOptions = getPreviewCatalogImportPresetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Import a known-format product export: parse with the preset parser, materialise the graph.

``price_list_id`` is the destination for the export's prices (its currency
wins); omit it to skip price import. ``tag_names`` are free-text tags applied
to every imported product, on top of any tags the export file itself carries.

``company_id`` / ``warehouse_id`` are the legal entity and destination
warehouse for a preset whose parser emits a stock position (a
``quantity``/``bin_code`` on the normalised graph); a preset that emits none
ignores them.
 * @summary Run Catalog Import Preset
 */
export const runCatalogImportPreset = (
  presetKey: string,
  bodyRunCatalogImportPreset: BodyRunCatalogImportPreset,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyRunCatalogImportPreset.data_file);
  if (
    bodyRunCatalogImportPreset.price_list_id !== undefined &&
    bodyRunCatalogImportPreset.price_list_id !== null
  ) {
    formData.append(`price_list_id`, bodyRunCatalogImportPreset.price_list_id);
  }
  if (
    bodyRunCatalogImportPreset.warehouse_id !== undefined &&
    bodyRunCatalogImportPreset.warehouse_id !== null
  ) {
    formData.append(`warehouse_id`, bodyRunCatalogImportPreset.warehouse_id);
  }
  if (
    bodyRunCatalogImportPreset.company_id !== undefined &&
    bodyRunCatalogImportPreset.company_id !== null
  ) {
    formData.append(`company_id`, bodyRunCatalogImportPreset.company_id);
  }
  if (bodyRunCatalogImportPreset.tag_names !== undefined) {
    bodyRunCatalogImportPreset.tag_names.forEach((value) =>
      formData.append(`tag_names`, value)
    );
  }
  if (bodyRunCatalogImportPreset.decision_row_indexes !== undefined) {
    bodyRunCatalogImportPreset.decision_row_indexes.forEach((value) =>
      formData.append(`decision_row_indexes`, value.toString())
    );
  }
  if (bodyRunCatalogImportPreset.decision_options !== undefined) {
    bodyRunCatalogImportPreset.decision_options.forEach((value) =>
      formData.append(`decision_options`, value)
    );
  }

  return customInstance<CatalogImportResultResponse>({
    url: `/api/v1/master-data/products/catalog-import/preset/${presetKey}/run`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getRunCatalogImportPresetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCatalogImportPreset>>,
    TError,
    { presetKey: string; data: BodyRunCatalogImportPreset },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runCatalogImportPreset>>,
  TError,
  { presetKey: string; data: BodyRunCatalogImportPreset },
  TContext
> => {
  const mutationKey = ['runCatalogImportPreset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runCatalogImportPreset>>,
    { presetKey: string; data: BodyRunCatalogImportPreset }
  > = (props) => {
    const { presetKey, data } = props ?? {};

    return runCatalogImportPreset(presetKey, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunCatalogImportPresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof runCatalogImportPreset>>
>;
export type RunCatalogImportPresetMutationBody = BodyRunCatalogImportPreset;
export type RunCatalogImportPresetMutationError = HTTPValidationError;

/**
 * @summary Run Catalog Import Preset
 */
export const useRunCatalogImportPreset = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runCatalogImportPreset>>,
      TError,
      { presetKey: string; data: BodyRunCatalogImportPreset },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof runCatalogImportPreset>>,
  TError,
  { presetKey: string; data: BodyRunCatalogImportPreset },
  TContext
> => {
  const mutationOptions = getRunCatalogImportPresetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Dry-run a picture folder against the catalogue. Writes nothing.

The request carries file names only, so this is cheap enough for the operator
to re-run after every rename on the drive.
 * @summary Preview Product Image Import
 */
export const previewProductImageImport = (
  productImageImportPreviewRequest: ProductImageImportPreviewRequest,
  signal?: AbortSignal
) => {
  return customInstance<ProductImageImportPreviewResponse>({
    url: `/api/v1/master-data/products/image-import/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: productImageImportPreviewRequest,
    signal
  });
};

export const getPreviewProductImageImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewProductImageImport>>,
    TError,
    { data: ProductImageImportPreviewRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewProductImageImport>>,
  TError,
  { data: ProductImageImportPreviewRequest },
  TContext
> => {
  const mutationKey = ['previewProductImageImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewProductImageImport>>,
    { data: ProductImageImportPreviewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return previewProductImageImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewProductImageImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewProductImageImport>>
>;
export type PreviewProductImageImportMutationBody =
  ProductImageImportPreviewRequest;
export type PreviewProductImageImportMutationError = HTTPValidationError;

/**
 * @summary Preview Product Image Import
 */
export const usePreviewProductImageImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewProductImageImport>>,
      TError,
      { data: ProductImageImportPreviewRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewProductImageImport>>,
  TError,
  { data: ProductImageImportPreviewRequest },
  TContext
> => {
  const mutationOptions = getPreviewProductImageImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Store ONE batch of picture files onto the products their names resolve to.

Every file comes back with its own outcome row, in the order it was sent, so
the wizard can reconcile the batch it uploaded without inferring anything.
 * @summary Run Product Image Import
 */
export const runProductImageImport = (
  bodyRunProductImageImport: BodyRunProductImageImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  bodyRunProductImageImport.files.forEach((value) =>
    formData.append(`files`, value)
  );
  formData.append(`match_key`, bodyRunProductImageImport.match_key);
  formData.append(`match_mode`, bodyRunProductImageImport.match_mode);
  if (bodyRunProductImageImport.overwrite !== undefined) {
    formData.append(
      `overwrite`,
      bodyRunProductImageImport.overwrite.toString()
    );
  }

  return customInstance<ProductImageImportResultResponse>({
    url: `/api/v1/master-data/products/image-import/run`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getRunProductImageImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runProductImageImport>>,
    TError,
    { data: BodyRunProductImageImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runProductImageImport>>,
  TError,
  { data: BodyRunProductImageImport },
  TContext
> => {
  const mutationKey = ['runProductImageImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runProductImageImport>>,
    { data: BodyRunProductImageImport }
  > = (props) => {
    const { data } = props ?? {};

    return runProductImageImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunProductImageImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof runProductImageImport>>
>;
export type RunProductImageImportMutationBody = BodyRunProductImageImport;
export type RunProductImageImportMutationError = HTTPValidationError;

/**
 * @summary Run Product Image Import
 */
export const useRunProductImageImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runProductImageImport>>,
      TError,
      { data: BodyRunProductImageImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof runProductImageImport>>,
  TError,
  { data: BodyRunProductImageImport },
  TContext
> => {
  const mutationOptions = getRunProductImageImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Summarise the file and test the chosen scope against its own provenance.

``company_id`` is optional: without one the provenance is still reported (so
the wizard can pre-empt the choice), it simply cannot be in conflict yet.
 * @summary Inspect Inventory Import
 */
export const inspectInventoryImport = (
  bodyInspectInventoryImport: BodyInspectInventoryImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyInspectInventoryImport.data_file);
  if (
    bodyInspectInventoryImport.company_id !== undefined &&
    bodyInspectInventoryImport.company_id !== null
  ) {
    formData.append(`company_id`, bodyInspectInventoryImport.company_id);
  }

  return customInstance<InventoryImportInspectResponse>({
    url: `/api/v1/master-data/products/inventory-import/inspect`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getInspectInventoryImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inspectInventoryImport>>,
    TError,
    { data: BodyInspectInventoryImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inspectInventoryImport>>,
  TError,
  { data: BodyInspectInventoryImport },
  TContext
> => {
  const mutationKey = ['inspectInventoryImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inspectInventoryImport>>,
    { data: BodyInspectInventoryImport }
  > = (props) => {
    const { data } = props ?? {};

    return inspectInventoryImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InspectInventoryImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof inspectInventoryImport>>
>;
export type InspectInventoryImportMutationBody = BodyInspectInventoryImport;
export type InspectInventoryImportMutationError = HTTPValidationError;

/**
 * @summary Inspect Inventory Import
 */
export const useInspectInventoryImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inspectInventoryImport>>,
      TError,
      { data: BodyInspectInventoryImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof inspectInventoryImport>>,
  TError,
  { data: BodyInspectInventoryImport },
  TContext
> => {
  const mutationOptions = getInspectInventoryImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Check every row against the database. Writes nothing.

The wizard's Column-mapping, Validation and Reconciliation steps all render
off this one response, so those three screens cannot disagree with each
other. Re-called whenever a per-row decision changes, because a decision
moves the reconciliation totals.

``posting_date`` is the nominated cut-over date. It is validated here even
though this call writes nothing — the wizard fires the dry run on the way
out of its source-and-scope step, so a date in a closed period, in the
future, or behind activity this warehouse already has is refused on the step
that chose it rather than part-way through a committed file.

``row_offset`` / ``row_limit`` / ``bucket`` page and filter the ROW LIST
only; the summary and the reconciliation are always whole-file. Paging is
server-side because a graded row carries its raw cells, its issues and its
projection — a real cut-over's 48,844 of them are tens of megabytes on one
request — and filtering is server-side for the consequence of that: a client
can only filter the rows it was sent, and it was sent one page.
 * @summary Plan Inventory Import
 */
export const planInventoryImport = (
  bodyPlanInventoryImport: BodyPlanInventoryImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyPlanInventoryImport.data_file);
  formData.append(`company_id`, bodyPlanInventoryImport.company_id);
  formData.append(`warehouse_id`, bodyPlanInventoryImport.warehouse_id);
  if (
    bodyPlanInventoryImport.preset_key !== undefined &&
    bodyPlanInventoryImport.preset_key !== null
  ) {
    formData.append(`preset_key`, bodyPlanInventoryImport.preset_key);
  }
  if (
    bodyPlanInventoryImport.identifier_column !== undefined &&
    bodyPlanInventoryImport.identifier_column !== null
  ) {
    formData.append(
      `identifier_column`,
      bodyPlanInventoryImport.identifier_column
    );
  }
  if (
    bodyPlanInventoryImport.quantity_column !== undefined &&
    bodyPlanInventoryImport.quantity_column !== null
  ) {
    formData.append(`quantity_column`, bodyPlanInventoryImport.quantity_column);
  }
  if (
    bodyPlanInventoryImport.bin_column !== undefined &&
    bodyPlanInventoryImport.bin_column !== null
  ) {
    formData.append(`bin_column`, bodyPlanInventoryImport.bin_column);
  }
  if (
    bodyPlanInventoryImport.name_column !== undefined &&
    bodyPlanInventoryImport.name_column !== null
  ) {
    formData.append(`name_column`, bodyPlanInventoryImport.name_column);
  }
  if (
    bodyPlanInventoryImport.category_column !== undefined &&
    bodyPlanInventoryImport.category_column !== null
  ) {
    formData.append(`category_column`, bodyPlanInventoryImport.category_column);
  }
  if (
    bodyPlanInventoryImport.price_column !== undefined &&
    bodyPlanInventoryImport.price_column !== null
  ) {
    formData.append(`price_column`, bodyPlanInventoryImport.price_column);
  }
  if (
    bodyPlanInventoryImport.cost_column !== undefined &&
    bodyPlanInventoryImport.cost_column !== null
  ) {
    formData.append(`cost_column`, bodyPlanInventoryImport.cost_column);
  }
  if (
    bodyPlanInventoryImport.posting_date !== undefined &&
    bodyPlanInventoryImport.posting_date !== null
  ) {
    formData.append(`posting_date`, bodyPlanInventoryImport.posting_date);
  }
  if (
    bodyPlanInventoryImport.currency_code !== undefined &&
    bodyPlanInventoryImport.currency_code !== null
  ) {
    formData.append(`currency_code`, bodyPlanInventoryImport.currency_code);
  }
  if (bodyPlanInventoryImport.base_unit !== undefined) {
    formData.append(`base_unit`, bodyPlanInventoryImport.base_unit);
  }
  if (bodyPlanInventoryImport.decision_row_indexes !== undefined) {
    bodyPlanInventoryImport.decision_row_indexes.forEach((value) =>
      formData.append(`decision_row_indexes`, value.toString())
    );
  }
  if (bodyPlanInventoryImport.decision_options !== undefined) {
    bodyPlanInventoryImport.decision_options.forEach((value) =>
      formData.append(`decision_options`, value)
    );
  }
  if (bodyPlanInventoryImport.row_offset !== undefined) {
    formData.append(
      `row_offset`,
      bodyPlanInventoryImport.row_offset.toString()
    );
  }
  if (bodyPlanInventoryImport.row_limit !== undefined) {
    formData.append(`row_limit`, bodyPlanInventoryImport.row_limit.toString());
  }
  if (
    bodyPlanInventoryImport.bucket !== undefined &&
    bodyPlanInventoryImport.bucket !== null
  ) {
    formData.append(`bucket`, bodyPlanInventoryImport.bucket);
  }

  return customInstance<InventoryImportPlanResponse>({
    url: `/api/v1/master-data/products/inventory-import/plan`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getPlanInventoryImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof planInventoryImport>>,
    TError,
    { data: BodyPlanInventoryImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof planInventoryImport>>,
  TError,
  { data: BodyPlanInventoryImport },
  TContext
> => {
  const mutationKey = ['planInventoryImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof planInventoryImport>>,
    { data: BodyPlanInventoryImport }
  > = (props) => {
    const { data } = props ?? {};

    return planInventoryImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlanInventoryImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof planInventoryImport>>
>;
export type PlanInventoryImportMutationBody = BodyPlanInventoryImport;
export type PlanInventoryImportMutationError = HTTPValidationError;

/**
 * @summary Plan Inventory Import
 */
export const usePlanInventoryImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof planInventoryImport>>,
      TError,
      { data: BodyPlanInventoryImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof planInventoryImport>>,
  TError,
  { data: BodyPlanInventoryImport },
  TContext
> => {
  const mutationOptions = getPlanInventoryImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Apply one slice of the plan: rows ``row_offset`` .. ``row_offset+row_limit``.

The slice is its own transaction. A slice that fails leaves every earlier
slice landed, and because each write is the DIFFERENCE between the file's
figure and the on-hand figure, re-running the whole file afterwards finds
those rows already present and writes nothing for them — so recovery is "run
it again", not "work out how far it got".

``run_id`` names the persisted run this slice belongs to. Omit it on the
first slice — the response carries the id the run was created with — and send
it on every later one, so all of a walk's slices land on ONE exception
report. It is re-checked against the scope and against a fingerprint of the
uploaded bytes: the wizard is stateless, so the file arrives again on every
slice, and nothing else could tell a resumed run from a different file.
 * @summary Commit Inventory Import
 */
export const commitInventoryImport = (
  bodyCommitInventoryImport: BodyCommitInventoryImport,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`data_file`, bodyCommitInventoryImport.data_file);
  formData.append(`company_id`, bodyCommitInventoryImport.company_id);
  formData.append(`warehouse_id`, bodyCommitInventoryImport.warehouse_id);
  if (
    bodyCommitInventoryImport.preset_key !== undefined &&
    bodyCommitInventoryImport.preset_key !== null
  ) {
    formData.append(`preset_key`, bodyCommitInventoryImport.preset_key);
  }
  if (
    bodyCommitInventoryImport.identifier_column !== undefined &&
    bodyCommitInventoryImport.identifier_column !== null
  ) {
    formData.append(
      `identifier_column`,
      bodyCommitInventoryImport.identifier_column
    );
  }
  if (
    bodyCommitInventoryImport.quantity_column !== undefined &&
    bodyCommitInventoryImport.quantity_column !== null
  ) {
    formData.append(
      `quantity_column`,
      bodyCommitInventoryImport.quantity_column
    );
  }
  if (
    bodyCommitInventoryImport.bin_column !== undefined &&
    bodyCommitInventoryImport.bin_column !== null
  ) {
    formData.append(`bin_column`, bodyCommitInventoryImport.bin_column);
  }
  if (
    bodyCommitInventoryImport.name_column !== undefined &&
    bodyCommitInventoryImport.name_column !== null
  ) {
    formData.append(`name_column`, bodyCommitInventoryImport.name_column);
  }
  if (
    bodyCommitInventoryImport.category_column !== undefined &&
    bodyCommitInventoryImport.category_column !== null
  ) {
    formData.append(
      `category_column`,
      bodyCommitInventoryImport.category_column
    );
  }
  if (
    bodyCommitInventoryImport.price_column !== undefined &&
    bodyCommitInventoryImport.price_column !== null
  ) {
    formData.append(`price_column`, bodyCommitInventoryImport.price_column);
  }
  if (
    bodyCommitInventoryImport.cost_column !== undefined &&
    bodyCommitInventoryImport.cost_column !== null
  ) {
    formData.append(`cost_column`, bodyCommitInventoryImport.cost_column);
  }
  if (
    bodyCommitInventoryImport.posting_date !== undefined &&
    bodyCommitInventoryImport.posting_date !== null
  ) {
    formData.append(`posting_date`, bodyCommitInventoryImport.posting_date);
  }
  if (
    bodyCommitInventoryImport.currency_code !== undefined &&
    bodyCommitInventoryImport.currency_code !== null
  ) {
    formData.append(`currency_code`, bodyCommitInventoryImport.currency_code);
  }
  if (bodyCommitInventoryImport.base_unit !== undefined) {
    formData.append(`base_unit`, bodyCommitInventoryImport.base_unit);
  }
  if (bodyCommitInventoryImport.decision_row_indexes !== undefined) {
    bodyCommitInventoryImport.decision_row_indexes.forEach((value) =>
      formData.append(`decision_row_indexes`, value.toString())
    );
  }
  if (bodyCommitInventoryImport.decision_options !== undefined) {
    bodyCommitInventoryImport.decision_options.forEach((value) =>
      formData.append(`decision_options`, value)
    );
  }
  if (bodyCommitInventoryImport.row_offset !== undefined) {
    formData.append(
      `row_offset`,
      bodyCommitInventoryImport.row_offset.toString()
    );
  }
  if (bodyCommitInventoryImport.row_limit !== undefined) {
    formData.append(
      `row_limit`,
      bodyCommitInventoryImport.row_limit.toString()
    );
  }
  if (
    bodyCommitInventoryImport.run_id !== undefined &&
    bodyCommitInventoryImport.run_id !== null
  ) {
    formData.append(`run_id`, bodyCommitInventoryImport.run_id);
  }

  return customInstance<InventoryImportResultResponse>({
    url: `/api/v1/master-data/products/inventory-import/commit`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getCommitInventoryImportMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof commitInventoryImport>>,
    TError,
    { data: BodyCommitInventoryImport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof commitInventoryImport>>,
  TError,
  { data: BodyCommitInventoryImport },
  TContext
> => {
  const mutationKey = ['commitInventoryImport'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof commitInventoryImport>>,
    { data: BodyCommitInventoryImport }
  > = (props) => {
    const { data } = props ?? {};

    return commitInventoryImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommitInventoryImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof commitInventoryImport>>
>;
export type CommitInventoryImportMutationBody = BodyCommitInventoryImport;
export type CommitInventoryImportMutationError = HTTPValidationError;

/**
 * @summary Commit Inventory Import
 */
export const useCommitInventoryImport = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof commitInventoryImport>>,
      TError,
      { data: BodyCommitInventoryImport },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof commitInventoryImport>>,
  TError,
  { data: BodyCommitInventoryImport },
  TContext
> => {
  const mutationOptions = getCommitInventoryImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * This company's recent import runs, newest first.

The way back to a cut-over whose browser tab is gone. Explicitly paged and
small: this is a "find the run I started" list, not an audit report.
 * @summary List Inventory Import Runs
 */
export const listInventoryImportRuns = (
  params: ListInventoryImportRunsParams,
  signal?: AbortSignal
) => {
  return customInstance<InventoryImportRunListResponse>({
    url: `/api/v1/master-data/products/inventory-import/runs`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInventoryImportRunsQueryKey = (
  params?: ListInventoryImportRunsParams
) => {
  return [
    `/api/v1/master-data/products/inventory-import/runs`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListInventoryImportRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryImportRuns>>,
  TError = HTTPValidationError
>(
  params: ListInventoryImportRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRuns>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInventoryImportRunsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryImportRuns>>
  > = ({ signal }) => listInventoryImportRuns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryImportRuns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInventoryImportRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryImportRuns>>
>;
export type ListInventoryImportRunsQueryError = HTTPValidationError;

export function useListInventoryImportRuns<
  TData = Awaited<ReturnType<typeof listInventoryImportRuns>>,
  TError = HTTPValidationError
>(
  params: ListInventoryImportRunsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRuns>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInventoryImportRuns>>,
          TError,
          Awaited<ReturnType<typeof listInventoryImportRuns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInventoryImportRuns<
  TData = Awaited<ReturnType<typeof listInventoryImportRuns>>,
  TError = HTTPValidationError
>(
  params: ListInventoryImportRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRuns>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInventoryImportRuns>>,
          TError,
          Awaited<ReturnType<typeof listInventoryImportRuns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInventoryImportRuns<
  TData = Awaited<ReturnType<typeof listInventoryImportRuns>>,
  TError = HTTPValidationError
>(
  params: ListInventoryImportRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRuns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Inventory Import Runs
 */

export function useListInventoryImportRuns<
  TData = Awaited<ReturnType<typeof listInventoryImportRuns>>,
  TError = HTTPValidationError
>(
  params: ListInventoryImportRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRuns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListInventoryImportRunsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One run and its totals, summed across every slice it has recorded.

``committed_rows`` against ``total_rows`` is what "failed on slice 100 of
245" looks like when the reviewer comes back to it.
 * @summary Get Inventory Import Run
 */
export const getInventoryImportRun = (runId: string, signal?: AbortSignal) => {
  return customInstance<InventoryImportRun>({
    url: `/api/v1/master-data/products/inventory-import/runs/${runId}`,
    method: 'GET',
    signal
  });
};

export const getGetInventoryImportRunQueryKey = (runId?: string) => {
  return [
    `/api/v1/master-data/products/inventory-import/runs/${runId}`
  ] as const;
};

export const getGetInventoryImportRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventoryImportRun>>,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInventoryImportRun>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryImportRunQueryKey(runId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInventoryImportRun>>
  > = ({ signal }) => getInventoryImportRun(runId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!runId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventoryImportRun>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInventoryImportRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventoryImportRun>>
>;
export type GetInventoryImportRunQueryError = HTTPValidationError;

export function useGetInventoryImportRun<
  TData = Awaited<ReturnType<typeof getInventoryImportRun>>,
  TError = HTTPValidationError
>(
  runId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInventoryImportRun>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryImportRun>>,
          TError,
          Awaited<ReturnType<typeof getInventoryImportRun>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInventoryImportRun<
  TData = Awaited<ReturnType<typeof getInventoryImportRun>>,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInventoryImportRun>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryImportRun>>,
          TError,
          Awaited<ReturnType<typeof getInventoryImportRun>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInventoryImportRun<
  TData = Awaited<ReturnType<typeof getInventoryImportRun>>,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInventoryImportRun>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Inventory Import Run
 */

export function useGetInventoryImportRun<
  TData = Awaited<ReturnType<typeof getInventoryImportRun>>,
  TError = HTTPValidationError
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInventoryImportRun>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetInventoryImportRunQueryOptions(runId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One page of the run's persisted exception report.

Paged because a cut-over that goes badly can name tens of thousands of rows,
and ``total`` is what tells the downloading client how many pages the CSV
still owes — a report that silently stopped at one page would be the partial
answer this surface exists to prevent.
 * @summary List Inventory Import Run Exceptions
 */
export const listInventoryImportRunExceptions = (
  runId: string,
  params?: ListInventoryImportRunExceptionsParams,
  signal?: AbortSignal
) => {
  return customInstance<InventoryImportRunExceptionListResponse>({
    url: `/api/v1/master-data/products/inventory-import/runs/${runId}/exceptions`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInventoryImportRunExceptionsQueryKey = (
  runId?: string,
  params?: ListInventoryImportRunExceptionsParams
) => {
  return [
    `/api/v1/master-data/products/inventory-import/runs/${runId}/exceptions`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListInventoryImportRunExceptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListInventoryImportRunExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListInventoryImportRunExceptionsQueryKey(runId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInventoryImportRunExceptions>>
  > = ({ signal }) => listInventoryImportRunExceptions(runId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!runId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInventoryImportRunExceptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInventoryImportRunExceptions>>
>;
export type ListInventoryImportRunExceptionsQueryError = HTTPValidationError;

export function useListInventoryImportRunExceptions<
  TData = Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
  TError = HTTPValidationError
>(
  runId: string,
  params: undefined | ListInventoryImportRunExceptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
          TError,
          Awaited<ReturnType<typeof listInventoryImportRunExceptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInventoryImportRunExceptions<
  TData = Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListInventoryImportRunExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
          TError,
          Awaited<ReturnType<typeof listInventoryImportRunExceptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInventoryImportRunExceptions<
  TData = Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListInventoryImportRunExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Inventory Import Run Exceptions
 */

export function useListInventoryImportRunExceptions<
  TData = Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
  TError = HTTPValidationError
>(
  runId: string,
  params?: ListInventoryImportRunExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInventoryImportRunExceptions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListInventoryImportRunExceptionsQueryOptions(
    runId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record how the walk ended, as the client that walked it reports it.

Only the client knows. The server sees N independent slice requests and
cannot tell the last one from a run that stopped after it — so a run nobody
finishes stays ``running``, which is the honest reading of a closed tab
rather than a missing feature.

``error_code`` is OUR closed set, translated by the frontend. A provider or
database message must never reach it: it is stored and read back over the
API.
 * @summary Finish Inventory Import Run
 */
export const finishInventoryImportRun = (
  runId: string,
  bodyFinishInventoryImportRun: BodyFinishInventoryImportRun,
  signal?: AbortSignal
) => {
  return customInstance<InventoryImportRun>({
    url: `/api/v1/master-data/products/inventory-import/runs/${runId}/finish`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bodyFinishInventoryImportRun,
    signal
  });
};

export const getFinishInventoryImportRunMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishInventoryImportRun>>,
    TError,
    { runId: string; data: BodyFinishInventoryImportRun },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finishInventoryImportRun>>,
  TError,
  { runId: string; data: BodyFinishInventoryImportRun },
  TContext
> => {
  const mutationKey = ['finishInventoryImportRun'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finishInventoryImportRun>>,
    { runId: string; data: BodyFinishInventoryImportRun }
  > = (props) => {
    const { runId, data } = props ?? {};

    return finishInventoryImportRun(runId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinishInventoryImportRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof finishInventoryImportRun>>
>;
export type FinishInventoryImportRunMutationBody = BodyFinishInventoryImportRun;
export type FinishInventoryImportRunMutationError = HTTPValidationError;

/**
 * @summary Finish Inventory Import Run
 */
export const useFinishInventoryImportRun = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof finishInventoryImportRun>>,
      TError,
      { runId: string; data: BodyFinishInventoryImportRun },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof finishInventoryImportRun>>,
  TError,
  { runId: string; data: BodyFinishInventoryImportRun },
  TContext
> => {
  const mutationOptions = getFinishInventoryImportRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
